/* eslint-disable max-len */
import { BUILD } from '../../src/utils/config';
import { getUserId, getUniqueSessionId } from '../utils/library';
import {
  ADD_VISA_ICON,
  ACK_SEARCH_ICON,
  AMEX_ICON,
  AMEX_LITE_ICON,
  APPROVED_ICON,
  BANK_STATEMENT_ICON,
  CARD_ICON_AMAZE_CARD,
  CARD_ICON_INVITE,
  CARD_ICON_TRANSFER_OVERSEAS,
  DISCOVER_ICON,
  DISCOVER_LITE_ICON,
  FIN_BACK_ICON,
  FIN_FRONT_ICON,
  FLOATING_LABEL_MY_INFO_ICON,
  GOVERNMENT_ICON,
  IN_DRIVING_BACK_ICON,
  IN_DRIVING_FRONT_ICON,
  IN_PASSPORT_BACK_ICON,
  IN_PASSPORT_FRONT_ICON,
  IN_VOTER_BACK_ICON,
  IN_VOTER_FRONT_ICON,
  MASTERCARD_ICON,
  MASTERCARD_LITE_ICON,
  MY_ACCOUNT_SBM_ICON,
  MY_INFO_MOBILE_ICON,
  NOTIFICATION_ICON_SBM_ICON,
  NRIC_ICON,
  NRIC_BACK_ICON,
  PAN_SAMPLE_ICON,
  PROCESSING_ICON,
  RECIPIENT_ICON,
  SELFIE_WITH_ID_ICON,
  UTILITY_ICON,
  VISA_SVG_ICON
} from '@Images';
import COLORS from '../common/styles/color-pallete';
import { FONT_FAMILY } from '../common/styles/fontStyles';
import { siftBeaconId } from '../constants/evs/siftBeaconKey';

/**
 * environment variables
 * @type {string}
 */
export const PROD_ENVIRONMENT = 'prod';
export const PREPROD_ENVIRONMENT = 'preprod';
export const DEV_ENVIRONMENT = 'dev';
export const QA_ENVIRONMENT = 'qa';

export const BASE_URL = '/app';

const setMyInfoCallBackUrl = () => {
  // eslint-disable-next-line no-console
  switch (BUILD) {
    case PROD_ENVIRONMENT:
      return `${BASE_URL}/sgkyc/callback`;

    case PREPROD_ENVIRONMENT:
    case QA_ENVIRONMENT:
      return `${BASE_URL}/sgkyc/staging/callback`;

    default:
      return `${BASE_URL}/sgkyc/staging/callback`;
  }
};

export const IN = 'IN';
/**
 * All User's account types
 * @type {string}
 */
export const INDIVIDUAL = 'INDIVIDUAL';
export const CORPORATE = 'CORPORATE';

/**
 * All User stauses
 * @type {string}
 */
export const REGISTERED = 'REGISTERED';
export const INITIATED = 'INITIATED';
export const ACKNOWLEDGED = 'ACKNOWLEDGED';
export const APPOINTMENT_SCHEDULED = 'APPOINTMENT_SCHEDULED';
export const REACKNOWLEDGED = 'REACKNOWLEDGED';
export const NEW_USER = 'NEW_USER';
export const ON_HOLD = 'ON_HOLD';
export const DORMANT = 'DORMANT';
export const APPROVED = 'APPROVED';
export const BLOCKED = 'BLOCKED';
export const CLOSED = 'CLOSED';
export const TERMINATE = 'TERMINATE';
export const REJECTED = 'REJECTED';
export const RISK_REJECTED = 'RISK_REJECTED';
export const IN_PROGRESS = 'IN_PROGRESS';
export const VERIFIED = 'VERIFIED';
export const REVIEW_REQUIRED = 'REVIEW_REQUIRED';
export const MISMATCH = 'MISMATCH';
export const V_KYC_STATUS_PENDING = 'PENDING';

/**
 * frontend routes
 * @type {string}
 */
export const ROOT_URL = BASE_URL;
export const DASHBOARD_URL = `${BASE_URL}/dashboard`;
export const AMAZE_URL = `${BASE_URL}/amaze`;
export const JUMIO = `${BASE_URL}/jumio`;
export const JUMIO_SUCCESS = `${BASE_URL}/jumio/success`;
export const JUMIO_ERROR = `${BASE_URL}/jumio/error`;
export const RESET_PASSWORD = `${BASE_URL}/reset-password`;
export const AMAZE_ACKNOWLEDGE_URL = `${BASE_URL}/amaze-acknowledge`;
export const AMAZE_ADD_ADDRESS_URL = `${BASE_URL}/amaze-add-address`;
export const REFERRAL_URL = `${BASE_URL}/referrals`;
export const USER_REGISTRATION_URL = `${BASE_URL}/user/registration`;
export const MY_INFO_CALL_BACK_URL = setMyInfoCallBackUrl();
export const MOBILE_VERIFICATION_URL = `${BASE_URL}/mobile-verification`;
export const EMAIL_VERIFICATION_URL = `${BASE_URL}/email-verification`;
export const CONSENT_PERMISSION_URL = `${BASE_URL}/consent-permission`;
export const APP_ONLY_CORRIDOOR_WELCOME_URL = `${BASE_URL}/app-only-corridors`;
export const ADD_PAYEE_URL = `${BASE_URL}/add-payee`;
export const SUBSCRIPTION_URL = `${BASE_URL}/subscribe`;
export const ACKNOWLEDGED_URL = `${BASE_URL}/acknowledgement/:payment_method/:status/:transaction_id?`;
export const RFI_URL = `${BASE_URL}/rfi`;
export const RFI_EKYC_URL = `${BASE_URL}/ekyc-rfi`;
export const MY_KYC = `${BASE_URL}/kyc`;
export const MY = 'MY';
export const TRANSFER_MONEY_URL = `${BASE_URL}/transfer-money`;
export const INSTAPOINTS_URL = `${BASE_URL}/instapoints`;
export const HISTORY_URL = `${BASE_URL}/transaction-history`;
export const PAYEE_LIST_URL = `${BASE_URL}/payee-list`;
export const USER_PROFILE_URL = `${BASE_URL}/user/profile`;
export const FEEDBACK_URL = `${BASE_URL}/feedback/:transaction_id`;
export const FEEDBACK_URL_V2 = `${BASE_URL}/feedback/:reason/:reference`;

export const SIGNUP_URL = `${BASE_URL}/signup`;
export const SIGNIN_URL = `${BASE_URL}/signin`;
export const QUICKPAY_URL = `${BASE_URL}/quickpay`;
export const INVITE_URL = `${BASE_URL}/invite`;
export const INVITE_BY_URL = `${INVITE_URL}/:referred_by_referral_code`;
export const FORGOT_PASSWORD_URL = `${BASE_URL}/forgot-password`;
export const CHANGE_PASSWORD_URL_START = `${BASE_URL}/reset-password`;
export const CHANGE_PASSWORD_URL = `${CHANGE_PASSWORD_URL_START}/:hash`;
export const SIGNUP_PIN_VERIFY_URL = `${BASE_URL}/signup/pin-verification`;
export const MY_INFO_RESGISTRATION_URL = `${BASE_URL}/my-info/registration`;
export const DEFAULT_AUTH_PATH = `${BASE_URL}/dashboard`;
export const DEFAULT_UNAUTH_PATH = '/';
export const MULTIPLE_TRANSACTION_URL = `${BASE_URL}/batch-transaction`;
export const FX_RATE_CHANGE_URL = `${BASE_URL}/fx-rate-change`;
export const MULTIPLE_TRANSACTION_ACK_URL = `${BASE_URL}/multiple-transaction-acknowledge`;
export const SG_ONBOARDING_CORPORATE_URL = `${BASE_URL}/BusinessRegistration`;
export const MANAGE_PAYMENT_OPTION_URL = `${BASE_URL}/manage/payment-option`;
export const NIUM_FOREX_URL_SEND_MONEY = `${BASE_URL}/nium-forex-send-money`;
export const NIUM_FOREX_URL = `${BASE_URL}/nium-forex`;
export const NIUM_FOREX_ESIGN_IN_CALLBACK_URL = `${BASE_URL}/nium-forex/es-callback`;
export const NIUM_FOREX_AADHAR_CALLBACK_URL = `${BASE_URL}/nium-forex/aadhar-verification-callback/:transaction_id`;
export const NIUM_FOREX_VIDEO_KYC_CALLBACK_URL = `${BASE_URL}/nium-forex/video-verification-callback/:transaction_id`;
export const POST_LOGOUT_URL = `${BASE_URL}/post-logout`;
export const NEW_SME_URL = `${BASE_URL}/migration-notice`;
export const HELP_CENTER = `${BASE_URL}/help-center`;
export const USER_REGISTRATION_ADDRESS = `${BASE_URL}/user/address`;
export const USER_RETRIEVE_INFO = `${BASE_URL}/user/retrieveInfo`;
export const MANUAL_ADDRESS_VERIFICATION = `${BASE_URL}/user/registration/manual-add-verification`;
export const MANUAL_ADDRESS_BILL_VERIFICATION = `${BASE_URL}/user/registration/manual-add-verification/bill`;
export const MANUAL_ADDRESS_BANK_VERIFICATION = `${BASE_URL}/user/registration/manual-add-verification/bank`;
export const MANUAL_ADDRESS_DRIVING_VERIFICATION = `${BASE_URL}/user/registration/manual-add-verification/license`;
export const ID_VERIFICATION_FAIL = `${BASE_URL}/user/registration/id-check-fail`;
export const OCR_VERIFICATION_URL = `${BASE_URL}/user/registration/ocr`;
export const HELP_CENTRE_CONSTANT = 'Help Centre';
export const HELP_CENTER_PUBLIC_PROFILE_URL = '?help-center-public-ticket-profile=true';
export const GOOGLE_RECAPTCHA_PUBLIC_URL = `${BASE_URL}/verification-recaptcha`;

/**
 * Referral base url
 */
export const REFERRAL_BASE_URL =
  'https://referral-link.onelink.me/gbf1/a43c48ca?deep_link_sub1=referral&deep_link_value=';

/**
 * Money gram url
 */
export const MONEY_GRAM_BASE_URL = 'https://www.moneygram.com';
export const MONEY_GRAM_LOCATION = `${MONEY_GRAM_BASE_URL}/mgo/us/en/locations`;
/**
 * Access to routes w.r.t user status
 * @type {{[p: string]: Array}}
 */
export const AUTHORIZATIONS = {
  [REGISTERED]: [
    ROOT_URL,
    USER_PROFILE_URL,
    DASHBOARD_URL,
    USER_REGISTRATION_URL,
    ADD_PAYEE_URL,
    SUBSCRIPTION_URL,
    MY_INFO_CALL_BACK_URL,
    MY_INFO_RESGISTRATION_URL,
    HELP_CENTER
  ],
  [INITIATED]: [
    ROOT_URL,
    USER_PROFILE_URL,
    DASHBOARD_URL,
    USER_REGISTRATION_URL,
    ACKNOWLEDGED_URL,
    RFI_URL,
    RFI_EKYC_URL,
    SUBSCRIPTION_URL,
    HELP_CENTER
  ],
  [ACKNOWLEDGED]: [
    ROOT_URL,
    USER_PROFILE_URL,
    DASHBOARD_URL,
    MOBILE_VERIFICATION_URL,
    ACKNOWLEDGED_URL,
    RFI_URL,
    RFI_EKYC_URL,
    SUBSCRIPTION_URL,
    AMAZE_ACKNOWLEDGE_URL,
    ADD_PAYEE_URL,
    HELP_CENTER
  ],
  [APPOINTMENT_SCHEDULED]: [
    ROOT_URL,
    USER_PROFILE_URL,
    DASHBOARD_URL,
    MOBILE_VERIFICATION_URL,
    ACKNOWLEDGED_URL,
    RFI_URL,
    RFI_EKYC_URL,
    SUBSCRIPTION_URL,
    HELP_CENTER
  ],
  [REACKNOWLEDGED]: [
    ROOT_URL,
    USER_PROFILE_URL,
    DASHBOARD_URL,
    MOBILE_VERIFICATION_URL,
    ACKNOWLEDGED_URL,
    RFI_URL,
    RFI_EKYC_URL,
    SUBSCRIPTION_URL,
    HELP_CENTER
  ],
  [NEW_USER]: [
    ROOT_URL,
    DASHBOARD_URL,
    MOBILE_VERIFICATION_URL,
    ACKNOWLEDGED_URL,
    RFI_URL,
    RFI_EKYC_URL,
    USER_REGISTRATION_URL,
    SUBSCRIPTION_URL,
    JUMIO_SUCCESS,
    JUMIO_ERROR,
    HELP_CENTER
  ],
  [ON_HOLD]: [
    ROOT_URL,
    DASHBOARD_URL,
    SUBSCRIPTION_URL,
    MOBILE_VERIFICATION_URL,
    RFI_URL,
    RFI_EKYC_URL,
    HELP_CENTER
  ],
  [DORMANT]: [ROOT_URL, DASHBOARD_URL, SUBSCRIPTION_URL, MOBILE_VERIFICATION_URL, HELP_CENTER],
  [APPROVED]: [
    ROOT_URL,
    DASHBOARD_URL,
    TRANSFER_MONEY_URL,
    MOBILE_VERIFICATION_URL,
    PAYEE_LIST_URL,
    HISTORY_URL,
    REFERRAL_URL,
    INSTAPOINTS_URL,
    USER_PROFILE_URL,
    ADD_PAYEE_URL,
    FEEDBACK_URL,
    ACKNOWLEDGED_URL,
    RFI_URL,
    RFI_EKYC_URL,
    SUBSCRIPTION_URL,
    MULTIPLE_TRANSACTION_URL,
    AMAZE_URL,
    AMAZE_ADD_ADDRESS_URL,
    JUMIO,
    JUMIO_SUCCESS,
    JUMIO_ERROR,
    MANAGE_PAYMENT_OPTION_URL,
    NEW_SME_URL,
    HELP_CENTER,
    MY_KYC
  ],
  [BLOCKED]: [ROOT_URL, DASHBOARD_URL, SUBSCRIPTION_URL, MOBILE_VERIFICATION_URL, HELP_CENTER], // session clear // send to signin - logoput scenario
  [CLOSED]: [], // session clear // send to signin- logpout scenario
  [TERMINATE]: [],
  [REJECTED]: [
    ROOT_URL,
    DASHBOARD_URL,
    SUBSCRIPTION_URL,
    MOBILE_VERIFICATION_URL,
    HELP_CENTER,
    RFI_URL
  ]
};

export const SME_BLACKLISTED_PATHS = [
  DASHBOARD_URL,
  MULTIPLE_TRANSACTION_URL,
  PAYEE_LIST_URL,
  HISTORY_URL,
  AMAZE_URL,
  NEW_SME_URL
];

export const NOT_ALLOWED_USER_STATUS = [CLOSED, TERMINATE];

/**
 * Constants regarding all form names
 * @type {string}
 */
export const FORMNAME_REQUEST_OTP = 'form-request-otp';
export const FORMNAME_APPLICANT_DETAILS = 'ApplicantDetails';
export const FORMNAME_DASHBAORD = 'Dashboard';
export const FORMNAME_QUICKPAY = 'Quickpay';
export const FORMNAME_SENDMONEY = 'Sendmoney';
export const FORMNAME_SENDMONEY_US = 'Sendmoney-us';
export const FORMNAME_DASHBBOARD_SENDMONEY = 'DashboardSendmoney';
export const FORMNAME_PERSONAL_DETAILS = 'PersonalDetails';
export const FORMNAME_INDIVIDUAL_DOCUMENT_UPLOAD = 'UploadIndividualFlowDocuments';
export const FORMNAME_INDIVIDUAL_PERSONAL_IMAGE_UPLOAD = 'UploadIndividualFlowPhoto';
export const FORMNAME_COMPANY_DETAILS = 'CompanyDetails';
export const FORMNAME_COMPANY_ADDRESS = 'CompanyAddress';
export const FORMNAME_COMPANY_DOCUMENTS = 'companyDocuments';
export const FORMNAME_FATCA = 'fatca';
export const FORMNAME_PAYMENT_METHOD = 'PaymentMethod';
export const GIFT_CODE = 'IR019';
export const LOAN_FACILITY_CODE = 'LOAN_FACILITY';
export const OVERSEAS_EDUCATION_CODE = 'IR003';
export const FAMILY_MAINTENANCE_CODE = 'IR002';
export const FORMNAME_BENEFICIARY_DETAILS = 'payeeDetails';
export const FORMNAME_HOMEPAGE_CALCULATOR = 'HomepageCalculator';
export const FORMNAME_RFI = 'rfi';
export const FORMNAME_PEOPLE_INFO_KYC = 'peopleInfoKYC';
export const FORMNAME_INCOMPLETE_SIGNUP = 'incomplete-signup-form';
export const FORMNAME_RESET_PASSWORD = 'resetPassword';
export const GOODS_SERVICE_FIELDS = 'goodsServiceFields';
export const FORMNAME_CONTACT_EDIT = 'contactDetails';
export const FORMNAME_AUTHORITY_LIST = 'authoritiesList';
export const FORMNAME_BUSINESS_PROFILE = 'businessProfile';
export const FORMNAME_MODAL = 'ModalForm';
export const FORMNAME_AU_EKYC = 'AU-EKyc-Modal';
export const FORMNAME_MULTI_TRANSACTIONS = 'multipleTransactions';
export const FORMNAME_MULTI_TRANSACTIONS_EDIT = 'editMultipleTransactions';
// export const FORMNAME_NEW_SIGN_UP = 'newSignUp';
export const FORMNAME_NEW_SIGN_UP = 'form-sign-up';
export const FORMNAME_SIGN_IN = 'form-sign-in';
export const FORMNAME_INDIVIDUAL_NEW_DOCUMENT_UPLOAD = 'form-upload-individual-flow-documents';

export const FORMNAME_AMAZE_ADD_ADDRESS = 'form-amaze-add-address';
export const FORMNAME_IFSC_FINDER = 'form-ifsc-finder';
export const BUSINESS_PROFILE = 'businessProfile';
export const PERSONAL_INFORMATION = 'personalInformation';
export const DOCUMENT_INFORMATION = 'documentInformation';
export const RETRIEVE_USER_INFORMATION = 'retrieveUserInformation';
export const EMPLOYMENT_INFORMATION = 'employmentInformation';
export const UPLOAD_DOC_FORM = 'uploadDocForm';
export const SCHEDULE_VERIFICATION = 'scheduleVerification';
export const ADDRESS_POA_DOCUMENT = 'ADDRESS_POA_DOCUMENT';
export const ADDRESS_WITH_SUPPORTING_DOCS = 'ADDRESS_WITH_SUPPORTING_DOCS';

export const MANUAL_ADDRESS_FORM = 'manual-address-from';
/**
 * Miscellaneous Constants
 * @type {string}
 */
export const COMMON_MESSAGE_TIMEOUT = 10000;
export const OTP_WAIT_TIME = 30;
export const OTP_RESEND_LIMIT = 4;
export const DEBOUNCE_PERIOD = 1300;
export const OTP_LENGTH = '6';
export const COUPON_DEVICE_WEB = 'WEB';
export const LANDSCAPE = 'LANDSCAPE';
export const PORTRAIT = 'PORTRAIT';
export const EU_REGION = [
  'FR',
  'AT',
  'BE',
  'BG',
  'CY',
  'HR',
  'DK',
  'CZ',
  'EE',
  'FI',
  'DE',
  'GR',
  'HU',
  'IS',
  'IE',
  'IT',
  'LV',
  'LI',
  'MT',
  'NL',
  'NO',
  'PL',
  'PT',
  'RO',
  'SK',
  'SI',
  'ES',
  'SE',
  'GB',
  'LT',
  'MC',
  'SM',
  'LU'
];

export const CORPORATE_USD_MAX_LENGTH_COUNTRIES = ['CN', 'HK', 'US'];
export const arrowTagPattern = /\(->(.*?)<-\)/;

//For this countries address configs are different from rest of EU countries.
export const EXCEPTIONAL_EU_ADDRESS_COUNTRIES = ['NL', 'DE', 'IT'];

export const FEE_BASED_MARKETS = ['AU', 'MY', 'SG', 'HK'];

export const EU = [
  'FR',
  'AT',
  'BE',
  'BG',
  'CY',
  'HR',
  'DK',
  'CZ',
  'EE',
  'FI',
  'DE',
  'GR',
  'HU',
  'IS',
  'IE',
  'IT',
  'LV',
  'LI',
  'MT',
  'NL',
  'NO',
  'PL',
  'PT',
  'RO',
  'SK',
  'SI',
  'ES',
  'SE',
  'LT',
  'MC',
  'SM',
  'LU'
];
export const GB = 'GB';

export const GOODS = 'GOODS';
export const SERVICE = 'SERVICE';

/**
 * individual document types
 * @type {string}
 */
export const INDIVIDUAL_POI = 'INDIVIDUAL_POI';
export const INDIVIDUAL_POA = 'INDIVIDUAL_POA';
export const FATCA_DECLARATION = 'FATCA_DECLARATION';
export const INDIVIDUAL_PERSONAL_IMAGE = 'INDIVIDUAL_PERSONAL_IMAGE';
export const TEXT_TYPE_DOCUMENTS = [
  'PERSONAL_IDENTIFICATION_NUMBER',
  'SOCIAL_INSURANCE_NUMBER',
  'FATCA_DECLARATION'
];

/**
 * Doc Timeline Header text
 */
export const DOC_TIMELINE_HEADER = {
  IDENTITY: 'Identity',
  ADDRESS: 'Address',
  PERSONAL_IMAGE: 'Selfie with ID'
};

export const DOC_SEQUENCE = ['POI', 'POA', 'PERSONAL_IMAGE', 'FATCA', 'CORP'];

/**
 * corporate document types
 * @type {string}
 */
export const COMPANY_DETAILS_DOCUMENT_TYPE = 'COMPANY_REGISTRATION';
export const APPLICANT_AUTHORITY_LETTER_TYPE = 'APPLICANT_AUTHORITY_LETTER';
export const APPLICANT_POA = 'APPLICANT_POA';
export const APPLICANT_POI = 'APPLICANT_POI';
export const APPLICANT_DETAILS_DOCUMENT_TYPE = 'APPLICANT_DOCUMENTS';
export const APPLICANT_PERSONAL_IMAGE = 'APPLICANT_PERSONAL_IMAGE';
export const COMPANY_DOCUMENT_TYPE = 'COMPANY_DOCUMENTS';
export const TYPE_PERSONAL_IMAGE = 'PERSONAL_IMAGE';
export const REPRESENTATIVE_PERSONAL_IMAGE = 'REPRESENTATIVE_PERSONAL_IMAGE';
export const REPRESENTATIVE_POI = 'REPRESENTATIVE_POI';
export const REPRESENTATIVE_POA = 'REPRESENTATIVE_POA';
export const TRANSACTION_INVOICE = 'TRANSACTION_INVOICE';
export const AADHAR_CODE = 'AADHAR_NUMBER';
export const SINGPASS_CODE = 'SINGPASS';
export const PAN_CODE = 'PAN';
export const VISA = 'VISA';
export const IKAD = 'IKAD';
export const PERSONAL_IDENTIFICATION_NUMBER_CODE = 'PERSONAL_IDENTIFICATION_NUMBER';
export const MEDICARE_CARD = 'MEDICARE_CARD';
export const ENTITY_TYPE_REPRESENTATIVE = 'COMPANY_REPRESENTATIVE';
export const REPRESENTATIVE_TYPES = [
  'SHAREHOLDER',
  'DIRECTOR',
  'OTHER',
  'UBO',
  'BENEFICIAL_OWNER',
  'AUTHORISED_SIGNATORY',
  'COMMISSIONER',
  'APPLICANT',
  'SHAREHOLDER_HOLDING_MORE_THAN_25PERCENT_SHARES',
  'SHAREHOLDER_HOLDING_MORE_THAN_10PERCENT_SHARES',
  'PEP',
  'PEP_HOLDING_MORE_THAN_10PERCENT_SHARES',
  'ENTITY_HOLDING_MORE_THAN_25PERCENT_SHARES',
  'ENTITY_HOLDING_MORE_THAN_10PERCENT_SHARES',
  'PARTNER',
  'COMPLIANCE_OFFICER',
  'AUTHORISED_PERSON'
];

/**
 * Constants used during social sign-up and sign-in
 * @type {string}
 */
export const SESSION_STORAGE_ACCOUNT_TYPE = 'ACCOUNT_TYPE';
export const SESSION_STORAGE_COUNTRY_CODE = 'COUNTRY_CODE';
export const SESSION_STORAGE_TNC = 'TNC';
export const SESSION_STORAGE_REFERRAL = 'REFERRAL_CODE';
export const SESSION_STORAGE_REGISTERED_BUSINESS_NAME = 'REGISTERED_BUSINESS_NAME';
export const SESSION_STORAGE_MOBILE_NUMBER = 'MOBILE_NUMBER';
export const SESSION_STORAGE_MOBILE_COUNTRY_CODE = 'MOBILE_COUNTRY_CODE';
export const SESSION_STORAGE_DEEPLINK = 'SESSION_STORAGE_DEEPLINK';
export const SESSION_STORAGE_IS_SIGNUP_API = 'IS_SIGNUP_API';

/**
 * dynamic cdns
 * @type {string}
 */
export const PLAID_CDN = 'https://cdn.plaid.com/link/v2/stable/link-initialize.js';

export const API_VERSION_V2 = 'v2';
export const CLIENT_NAME = 'Instarem';
export const PRODUCT_IDENTITY = 'identity';
export const PLAID_CREDS = 'Plaid_creds';

/**
 * Notes
 * @type {string}
 */
export const PASSWORD_TOOLTIP =
  'Min 8: must contain 1 uppercase, lowercase, number and special character, except < >';
export const SG_SELFIE_DS =
  'Please click below to take a picture with your NRIC/FIN. Please hold your NRIC/FIN close to you as shown in the sample photograph. If you are facing a problem with clicking a clear picture, you can also upload a picture with you holding your NRIC/FIN. Please do ensure that the NRIC/FIN is clearly visible on the selfie.\n\nNote: Kindly ensure that you hold the same document NRIC or FIN as uploaded by you in the last step.';
export const INVITE_AND_EARN = `Invite and Earn`;
export const INVITE_MSG =
  'Hey, I am inviting you to use Instarem for easy and cost-effective overseas money transfers. Sign up using my referral code below and earn rewards on your first transfer';
export const PEP_TOOLTIP =
  'A PEP (Politically Exposed Person) is a current or former senior official in the executive, legislative, administrative, military, or judicial branch of a government, a senior official of a political party, or a senior executive of a government owned enterprise. Also included in the definition of a PEP are immediate family members or close associates of a person that meets the description above.';
export const NOTE_US =
  'USD transfers to countries other than the US may be subject to additional receiving bank charges that may impact the final beneficiary amount';
export const NOTE_EU =
  'Note: Currently, we only support EUR as a sending currency. Please ensure you hold EUR account, otherwise your bank may charge you additionally for currency conversion for which Instarem would not be liable.';
export const NOTE_INR = `This transaction may be processed through SWIFT. Your recipient may not receive the full INR amount indicated, as additional receiving bank charges may apply.`;
export const NOTE_IN =
  'Note: As directed by RBI, 18% GST is applicable on Fees and 0.18% GST or INR 45 (whichever is higher) is applicable as FX conversion GST on the amount being converted to foreign currency (0.18% for conversion upto INR 1,00,000/ and 0.09% of value exceeding INR 1,00,000/-)';
export const NOTE_PHP =
  'For receiving amount above 150000 PHP, the transaction may be subject to additional charges and may impact the final beneficiary amount.';
export const cashPickupUrl = 'https://www.instarem.com/help-personal/faq/?faqid=40370';
export const workingHoursUrl = 'https://www.instarem.com/help-personal/faq/?faqid=40356';
export const idUrl = 'https://www.instarem.com/help-personal/faq/?faqid=40360';
export const faqUrl = 'https://www.instarem.com/help-personal/faq/?faqid=40375';
export const CASH_PAYOUT_NOTE = `Your recipient can collect the cash at any of our available  <a href=${cashPickupUrl} target="_blank">cash pick-up locations</a>  during <a href=${workingHoursUrl} target="_blank">working hours</a> by sharing their <a href=${idUrl} target="_blank">valid ID</a> and cash pick-up reference ID, which will be shared via email once you fund your transfer.`;
// export const NOTE_EXTRA = 'There may be additional fees charged by the receiving bank for which Instarem would not be responsible.';
export const JUMIO_CONSENT =
  'I consent for Jumio Corporation on behalf of Instarem to perform identity verification of myself, using, as well comparing, live photograph data of myself and my identity document. I am informed that my data will be retained as long as it is necessary to carry out identity verification and for the period required by Anti-Money laundering laws. Please read more information on our Privacy Policy. By clicking save and continue you declare that this and all the other information provided by you to Instarem is True and Correct.';
export const AML_CONSENT_AU =
  'To enable us to verify your identity, we may disclose personal information such as your name, date of birth, and address to a credit reporting agency (CRA) or government agency to obtain an assessment of whether that personal information matches information held by the CRA or government agency (including as your agent) from its third party data sources to which your personal information may also be disclosed. The CRA may give us, and may retain for its own use, a report on that assessment and to do so the CRA and third party data sources may use personal information about you and other individuals in their files. Alternative means of verifying you are available on request. If we are unable to verify your identity using information held by a CRA or government agency we will provide you with a notice to this effect and verify your identity using an alternative method acceptable to us. I hereby give our full and informed consent to Instarem Pty Ltd to access and confirm our name, date of birth and address with a credit reporting agency (CRA), authority for the CRA, and government agency to act as my agent for the purposes of undertaking an electronic identity verification.';
export const INSTAPOINTS_TOOLTIP = `You earn Instarem reward points 'InstaPoints' on each transfer and can redeem them on any transfer. Please read more on InstaPoints at our help center.`;
export const COUPON_TOOLTIP = 'If you have a coupon, apply it here.';
export const INVALID_PASSWORD = 'Your password does not follow InstaRem password policy';
export const NOTE_SEND_CURRENCY_INR =
  'Note: Sending funds to Malaysia and Hong Kong is temporarily disabled.';
export const BSI_TITLE =
  'Instarem is certified  on ISO 27001 - Global Standard on Information Security Management Systems, which ensures adequate and proportionate security controls that protect information assets shared with us by our clients.';
export const USD_TO_USD_DISCLAIMER =
  'USD to USD for international transfers only (not available for USA domestic transfers)';
export const DASHBOARD_EU_NOTE = ['BG', 'HR', 'CZ', 'DK', 'HU', 'PL', 'RO', 'SE', 'GB'];
export const NOTE_FOR_CAD_DESTINATION =
  'CAD transfers may be subjected to SWIFT charges(typically, between CAD 15 and 30), which may impact the amount received.';

export const US_INDIVIDUAL_NOTE = 'Now introducing USD to USD international transfers';

export const US_CORPORATE_NOTE =
  'New! Send USD globally. Pay your vendors, subsidiaries, and employees in US dollars. Just select USD in your recipient details to get started.';

export const SERVICE_UNAVAILABLE_MESSAGE_PART =
  'Transfers from India are currently unavailable due to a temporary issue with our banking partner';

export const CAPTCHA_TOKEN_ERROR = 'Oops! Something went wrong. Please try again shortly';

export const SERVICE_UNAVAILABLE_MODAL_TEXT = {
  header: 'New service, same great experience!',
  introText:
    'While Instarem services are temporarily paused, you can continue to send money overseas via our partner company, ',
  descText:
    'It is a regulated and trusted provider of financial products and remittance services powered by global fintech leader, Nium. '
};

/**
 * constants regarding manual
 * @type {string}
 */

/**
 * constants regarding GTM
 * @type {string}
 */
export const GTM_HEAD_ID = 'GTM_HEAD_ID';
export const GTM_BODY_ID = 'GTM_BODY_ID';
export const SIFT_SCRIPT_ID = 'SIFT_SCRIPT_ID';

/**
 * composes gtm html to inject
 * @return {string}
 */
export function GTM_HEAD(GTM_ID) {
  if (BUILD !== 'prod') {
    return `(function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':
  new Date().getTime(),event:'gtm.js'}); var f=d.getElementsByTagName(s)[0],
  j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src=
  'https://www.googletagmanager.com/gtm.js?id='+i+dl+ '&gtm_auth=Rms8_KFQDp2A7OyBU4w5MQ&gtm_cookies_win=x';f.parentNode.insertBefore(j,f);
  })(window,document,'script','dataLayer','${GTM_ID}')`;
  } else {
    return `(function (w, d, s, l, i) {
      w[l] = w[l] || [];
      w[l].push({
        'gtm.start': new Date().getTime(),
        event: 'gtm.js'
      });
      var f = d.getElementsByTagName(s)[0],
        j = d.createElement(s),
        dl = l != 'dataLayer' ? '&l=' + l : '';
      j.async = true;
      j.src =
        'https://www.googletagmanager.com/gtm.js?id=' + i + dl;
      f.parentNode.insertBefore(j, f);
    })(window, document, 'script', 'dataLayer', '${GTM_ID}');`;
  }
}

export function createSIFTScript() {
  let userId = getUserId();
  let sessionId = getUniqueSessionId();
  return `var _user_id = '${
    userId || ''
  }'; // Set to the user's ID, username, or email address, or '' if not yet known.
  var _session_id = '${
    sessionId || ''
  }'; // Set to a unique session ID for the visitor's current browsing session.

  var _sift = window._sift = window._sift || [];
  _sift.push(['_setAccount', '${siftBeaconId}']);
  _sift.push(['_setUserId', _user_id]);
  _sift.push(['_setSessionId', _session_id]);
  _sift.push(['_trackPageview']);

 (function() {
   function ls() {
     var e = document.createElement('script');
     e.src = 'https://cdn.sift.com/s.js';
     document.body.appendChild(e);
   }
   if (window.attachEvent) {
     window.attachEvent('onload', ls);
   } else {
     window.addEventListener('load', ls, false);
   }
 })();`;
}
export function GTM_BODY(GTM_ID) {
  let iframe = document.createElement('iframe');
  //for making clevertap live on production comment out below code
  iframe.setAttribute('src', `https://www.googletagmanager.com/ns.html?id=${GTM_ID}`);
  iframe.setAttribute('height', '0');
  iframe.setAttribute('width', '0');
  iframe.setAttribute('style', 'display:none;visibility:hidden');
  return iframe;
}

/**
 * constants regarding responsiveness
 * @type {number}
 */
export const ALTERNATE_WIDTH = 789; //for ipad

export const DEVICE_DESKTOP = 'DEVICE_DESKTOP';
export const DEVICE_MOBILE = 'DEVICE_MOBILE';

export const VISA_DEBIT_CARD = 'VISA DEBIT CARD';
export const IPADS_ALTERNATE_WIDTH = 865;
/**
 * screen names
 */
export const SCREEN_NAME_JUMIO_VERIFICATION = 'jumio_verification';
export const SCREEN_NAME_DOCUMENT_UPLOAD = 'individual_documents_upload';
export const SCREEN_NAME_PHOTO_UPLOAD = 'individual_photo_upload';
export const SCREEN_NAME_SEND_MONEY = 'send_money';
export const SCREEN_NAME_PERSONAL_DETAILS = 'personal_details';
export const SCREEN_NAME_POA_DETAILS = 'poa_render_page';
export const SCREEN_NAME_POA_UPLOAD_DETAILS = 'poa_upload_page';

export const SCREEN_NAME_PERSONAL_DETAILS_US = 'personal_details_us';
export const SCREEN_NAME_SSN = 'individual_ssn_verification';
export const SCREEN_NAME_PERSONAL_DETAILS_IN = 'personal_details_in';
export const SCREEN_NAME_MOBILE_VERIFICATION = 'mobile_verification';
export const SCREEN_NAME_ADD_BENEFICIARY = 'add_beneficiary';
export const SCREEN_NAME_BENE_ADDITIONAL_INFO = 'bene_additional_info';
export const SCREEN_NAME_BENE_INFO_CORRECTION = 'bene_info_correction';
export const SCREEN_NAME_ADD_BENEFICIARY_SG = 'add_beneficiarySG';
export const SCREEN_NAME_SCHEDULE_INTERVIEW = 'schedule_interview';
export const SCREEN_NAME_PAYMENT_REVIEW = 'payment_review';
export const SCREEN_NAME_ACKNOWLEDGEMENT = 'acknowledgement';
export const SCREEN_NAME_AWAITING_ACKNOWLEDGEMENT = 'awaiting_acknowledgement';
export const SCREEN_NAME_FAILED_ACKNOWLEDGEMENT = 'failed_acknowledgement';
export const SCREEN_NAME_PAYMENT_METHOD = 'payment_method';
export const SCREEN_NAME_FATCA = 'fatca';
export const SCREEN_NAME_APPLICANT_DETAILS = 'applicant_details';
export const SCREEN_NAME_COMPANY_DETAILS = 'company_details';
export const SCREEN_NAME_COMPANY_ADDRESS = 'company_address';
export const SCREEN_NAME_INFORMATION_SCREEN = 'information_screen';
export const SCREEN_NAME_AUTHORITY_INFO = 'authority_info';
export const SCREEN_NAME_COMPANY_DOCUMENTS = 'company_documents';
export const SCREEN_NAME_INTERVIEW_ACKNOWLEDGEMENT = 'interview_acknowledgement';
export const SCREEN_NAME_MOBILE_VERIFICATION_TRANSACTION = 'mobile_verification_transaction';
export const SCREEN_NAME_MULTIPLE_TRANSACTIONS = 'multiple_transactions';
export const SCREEN_NAME_MULTIPLE_TRANSACTIONS_FX_RATE_CHANGE =
  'multiple_transactions_fx_rate_change';
export const SCREEN_NAME_BUSINESS_PROFILE = 'business_profile';

export const SCREEN_NAME_APPLE_PAY_VERIFICATION = 'apple_pay_verification';
/**
 * character length for see more/less functionality
 * @type {number}
 */
export const SEE_MORE_LESS_CHAR_LENGTH = 200;

/**
 * arrays for file upload
 * @type {array}
 */
export const FILE_FORMAT_IMAGE_ONLY = ['image/png', 'image/jpg', 'image/jpeg'];
export const FILE_FORMAT_PDF_ONLY = ['application/pdf'];
export const FILE_FORMAT_PDF_IMAGE = ['image/png', 'image/jpg', 'image/jpeg', 'application/pdf'];
export const FILE_FORMAT_EXT_IMAGE_ONLY = ['.png', '.jpg', '.jpeg'];
export const FILE_FORMAT_VIDEO_ONLY = ['.mp4', '.mov', '.wmv', '.flv', '.mkv', '.quicktime'];
export const FILE_FORMAT_DOCUMENT_ONLY = ['.doc', '.docx', '.txt'];
export const FILE_FORMAT_DOCUMENT_PDF_ONLY = ['.pdf'];
/**
 * dropdown codes
 */
export const EMPLOYMENT_STATUS_DROPDOWN = 'EMPLOYMENT_STATUS';
/**
 * clevertap web push notification config
 * @type {string}
 */
export const WEB_PUSH_TITLE_TEXT = 'Would you like to receive Push Notifications ?';
export const WEB_PUSH_BODY_TEXT = 'Would you like to enable push notifications?';
export const WEB_PUSH_OK_BTN_TEXT = 'Enable';
export const WEB_PUSH_REJECT_BTN_TEXT = 'No, Thanks';
export const WEB_PUSH_OK_BTN_COLOR = '#2baadf';
export const WEB_PUSH_HIDE_POWERED_BY = true;
export const WEB_PUSH_NOTIFY_TIME = 15000;
export const WEB_PUSH_NOTIFY_SHOW_AFTER_TIME = 10000;

/**
 * encryptData For
 */
export const ENCRYPT_DATA_FOR_DOCUMENT_CODE = [PAN_CODE];
export const DISABLE_FIELDS_ON_EVERIFICATION_ATTEMPT = [
  PERSONAL_IDENTIFICATION_NUMBER_CODE,
  PAN_CODE
];
export const MANDATORY_DOCUMENT_UPLOAD_FOR = [PAN_CODE];
export const DONOT_INITIALIZE_DOCS = [MEDICARE_CARD];

/**
 * conditional industry type on employment status
 */
export const CONDITIONAL_EMPLOYMENT_STATUS = ['EMPLOYED', 'SELF_EMPLOYED'];

/**
 * min INR amount for overseas education as a reason for transfer
 */
export const OVERSEAS_EDUCATION_USD_MIN_AMOUNT = 5000;

/**
 * To storewhich promotions is applied on sendmoney.
 */
export const INSTAPOINTS = 'instapoints';
export const COUPON_CODE = 'coupon';

/**
 * ACH Transaction code
 */
export const CFSB_USD_US = 'CFSB_USD_US';

/**
 * DOC upload contsants
 */
export const EXCLUDE_KEYS_IN_DOC_DETAILS = [
  'identity_number',
  'date_of_issue',
  'date_of_expiry',
  'document_detail_id',
  'document_detail_id_back'
];

/**
 * list of user's possible status before the APPROVED status of the user
 */
export const STATUS_BEFORE_APPROVED = [REGISTERED, INITIATED, ACKNOWLEDGED];

/**
 * US KYC verification types
 */
export const SSN_VERIFICATION = 'ssn_verification';
export const DOCUMENT_VERIFICATION = 'document_verification';

/**
 * SG flow, for note change on ACK screen for DBS bank
 */
export const DBS_BANK_NAME = 'DBS Bank';

/**
 * InstaPoints to USD rate
 */
export const IP_TO_USD_CONVERSION_RATE = 0.025;

/**
 * transaction status code
 */
export const AWAITING_PAYMENT = 'AWAITING_PAYMENT';
export const AT_RECEPIENT_BANK = 'AT_RECEPIENT_BANK';
export const READY_FOR_COLLECTION = 'READY_FOR_COLLECTION';
export const TRANSFER_CREATED = 'TRANSFER_CREATED';
export const TRANSFER_FUNDED = 'TRANSFER_FUNDED';
export const PROCESSING = 'PROCESSING';
export const RFI_DRAFT = 'DRAFT';
export const PAID = 'PAID';
export const CANCELLED = 'CANCELLED';
export const REFUNDED = 'REFUNDED';
export const AUTO_CANCELLED = 'AUTO_CANCELLED';
export const CANCELLED_BY_USER = 'CANCELLED_BY_USER';
export const FAILED = 'FAILED';
export const RETURNED = 'RETURNED';
export const DELINKED = 'DE_LINKED';
export const REFUND_REQUESTED = 'REFUND_REQUESTED';
export const REFUND_INITIATED = 'REFUND_INITIATED';
export const REFUND_PROCESSING = 'REFUND_PROCESSING';
export const REFUND = 'REFUND';
export const UPCOMING = 'UPCOMING';
export const SCHEDULED = 'SCHEDULED';
export const PROCESSED_BY_CLEARING = 'PROCESSED_BY_CLEARING';
export const SENT_TO_BENEFICIARY_BANK = 'SENT_TO_BENEFICIARY_BANK';

export const PAYMENT_NOT_RECEIVED_STATE = [AWAITING_PAYMENT, TRANSFER_CREATED];

export const TRANSACTION_FINAL_STATES = [
  PAID,
  CANCELLED,
  REFUND,
  REFUNDED,
  AUTO_CANCELLED,
  CANCELLED_BY_USER,
  FAILED,
  RETURNED,
  UPCOMING,
  SCHEDULED
];

export const PAY_IN_STATES = [TRANSFER_CREATED, TRANSFER_FUNDED];
export const INCOMPLETE_REFUND_STATES = [REFUND_REQUESTED, REFUND_INITIATED, REFUND_PROCESSING];
export const REFUND_STATES = [REFUND_REQUESTED, REFUND_INITIATED, REFUND_PROCESSING, REFUNDED];

export const EMPLOYED = 'EMPLOYED';
export const SELF_EMPLOYED = 'SELF_EMPLOYED';
export const UNEMPLOYED = 'UNEMPLOYED';
export const STUDENT = 'STUDENT';

export const TRANSACTION_TIMELINE_LABELS = {
  transferStatus: 'Transfer status',
  txnBeachedDesc: 'It is taking longer than we expected',
  txnBeachedToolTip: `Sometimes there are delays on the bank network or we simply need to run additional checks.
   Don’t worry, your money is safe and it will reach your recipient soon. Check back in an hour or two.`,
  informationRequired: 'Information requested',
  rfiInformationRequired: 'Extra information requested',
  seeDetails: 'See details',
  contactUs: 'contact us',
  transferTracker: 'Transfer tracker',
  shouldArrive: 'Should arrive to us',
  shouldPaidOutBy: 'Should be paid out by',
  awaitingAdditionalInfo: 'Awaiting additional information',
  reviewingDocs: 'We are reviewing submitted documents',
  reviewingDocsToolTip: 'Document review typically takes around 24 hours.',
  shouldBeCollectedBy: 'Should be ready to collect by',
  trackThisTransfer: 'Track this transfer',
  refundSubHeader: 'Refunds typically take {XX-XX} business days'
};
export const EGIRO_TEXT = `To get a more in-depth look at the status of transfers
 funded through your linked bank account, head over to the Instarem app.`;
export const DEEMED_PAID_SUB_STATUS_TEXT =
  "We've sent the money to your recipient's bank. If it hasn't arrived yet, please check again after some time.";
export const DEEMED_PAID_TIMELINE_TEXT =
  "We've successfully sent the money to your recipient's bank. If it hasn't arrived yet, please check again after some time.";

export const PAYTO_TEXT = {
  deLinkMessage: `Your account {PAY_TO_BANK_ACCOUNT_NUMBER} may be unlinked or not authorised. Please delete it under Payment Methods and link a new account through the Instarem app.`,
  failedMessage: `There was an error processing your transfer with account {PAY_TO_BANK_ACCOUNT_NUMBER}. Please link a new account through the Instarem app or try a different payment method.`,
  downloadMessage: `To get a more in-depth look at the status of transfers funded through PayTo transfers, head over to the Instarem app.`
};
/**
 * Clevertap Constants - FLOW TYPE
 */
export const FLOW_TYPE = {
  TRANSACTION: 'TRANSACTION',
  ONBOARDING: 'ONBOARDING',
  DASHBOARD: 'DASHBOARD',
  INSTAPOINT: 'INSTAPOINT',
  SIGNIN: 'SIGNIN',
  BENEFICIARY: 'BENEFICIARY'
};
/**
 * CleverTap Constants - ERROR TYPE
 */
export const ERROR_TYPE = {
  VALIDATION: 'VALIDATION',
  NETWORK: 'NETWORK',
  SYSTEM: 'SYSTEM',
  THIIRD_PARTY: 'THIIRD_PARTY'
};
/**
 * Clevertap Constants - Event Name
 */
export const EVENT_NAME = {};
EVENT_NAME[FORMNAME_REQUEST_OTP] = 'form-request-otp';
EVENT_NAME[FORMNAME_APPLICANT_DETAILS] = 'ApplicantDetails';
EVENT_NAME[FORMNAME_DASHBAORD] = 'Dashboard';
EVENT_NAME[FORMNAME_QUICKPAY] = 'Quickpay';
EVENT_NAME[FORMNAME_SENDMONEY] = 'Sendmoney';
EVENT_NAME[FORMNAME_DASHBBOARD_SENDMONEY] = 'DashboardSendmoney';
EVENT_NAME[FORMNAME_PERSONAL_DETAILS] = {
  formName: FORMNAME_PERSONAL_DETAILS,
  flowType: FLOW_TYPE.ONBOARDING
};
EVENT_NAME[FORMNAME_INDIVIDUAL_DOCUMENT_UPLOAD] = {
  formName: 'form-upload-individual-flow-documents',
  flowType: FLOW_TYPE.ONBOARDING
};
EVENT_NAME[FORMNAME_INDIVIDUAL_PERSONAL_IMAGE_UPLOAD] = 'UploadIndividualFlowPhoto';
EVENT_NAME[FORMNAME_COMPANY_DETAILS] = 'CompanyDetails';
EVENT_NAME[FORMNAME_COMPANY_ADDRESS] = 'CompanyAddress';
EVENT_NAME[FORMNAME_COMPANY_DOCUMENTS] = 'companyDocuments';
EVENT_NAME[FORMNAME_FATCA] = 'fatca';
EVENT_NAME[FORMNAME_PAYMENT_METHOD] = 'PaymentMethod';
EVENT_NAME[FORMNAME_BENEFICIARY_DETAILS] = {
  formName: FORMNAME_BENEFICIARY_DETAILS,
  flowType: FLOW_TYPE.BENEFICIARY
};
EVENT_NAME[FORMNAME_HOMEPAGE_CALCULATOR] = 'HomepageCalculator';
EVENT_NAME[FORMNAME_RFI] = 'rfi';
EVENT_NAME[FORMNAME_PEOPLE_INFO_KYC] = 'peopleInfoKYC';
EVENT_NAME[FORMNAME_INCOMPLETE_SIGNUP] = 'incomplete-signup-form';
EVENT_NAME[FORMNAME_RESET_PASSWORD] = 'resetPassword';
EVENT_NAME[FORMNAME_CONTACT_EDIT] = 'contactDetails';
EVENT_NAME[FORMNAME_AUTHORITY_LIST] = 'authoritiesList';
EVENT_NAME[FORMNAME_BUSINESS_PROFILE] = 'businessProfile';
EVENT_NAME[BUSINESS_PROFILE] = 'businessProfile';
EVENT_NAME[FORMNAME_MODAL] = 'ModalForm';
EVENT_NAME[FORMNAME_AU_EKYC] = 'AU-EKyc-Modal';
EVENT_NAME[FORMNAME_MULTI_TRANSACTIONS] = 'multipleTransactions';
EVENT_NAME[FORMNAME_MULTI_TRANSACTIONS_EDIT] = 'editMultipleTransactions';
EVENT_NAME[FORMNAME_NEW_SIGN_UP] = {
  formName: 'SignUp',
  flowType: FLOW_TYPE.ONBOARDING
};
EVENT_NAME[FORMNAME_SIGN_IN] = {
  formName: 'SignIn',
  flowType: FLOW_TYPE.SIGNIN
};
EVENT_NAME[FORMNAME_INDIVIDUAL_NEW_DOCUMENT_UPLOAD] = {
  formName: 'form-upload-individual-flow-documents',
  flowType: FLOW_TYPE.ONBOARDING
};

/**
 * card supported rouring code
 */
export const CARD_SUPPORTED_ROUTING_CODE = ['VISA_DEBIT_CARD', 'GEO_SWIFT_CARD'];

/**
 * cash payout supported rouring code
 */
export const CASH_PAYOUT_SUPPORTED_ROUTING_CODE = ['CASH_PAYOUT', 'MONEYGRAM_CASH_PAYOUT'];

export const SME_NEW_REGISTRATION_FLOW_COUNTRY_CODES = ['SG'];

export const SME_NEW_REGISTRATION_FLOW_STATUSES = [REGISTERED, INITIATED];

export const REMOVE_TRANSFORM_FROM_SCREENS = [
  SCREEN_NAME_SEND_MONEY,
  SCREEN_NAME_PERSONAL_DETAILS,
  SCREEN_NAME_DOCUMENT_UPLOAD,
  SCREEN_NAME_FAILED_ACKNOWLEDGEMENT
];
export const STICKY_HEADER_SCREEN = [
  SCREEN_NAME_PERSONAL_DETAILS,
  SCREEN_NAME_DOCUMENT_UPLOAD,
  SCREEN_NAME_FAILED_ACKNOWLEDGEMENT
];

export const MY_INFO_REDIRECT_CONDITION = [REGISTERED, INITIATED];

export const SAMPLE_DOC_IMAGE = {
  FIN: FIN_FRONT_ICON,
  FIN_BACK: FIN_BACK_ICON,
  INDIVIDUAL_SELFIE_WITH_ID: SELFIE_WITH_ID_ICON,
  BANK_STATEMENT: BANK_STATEMENT_ICON,
  GOVERNMENT_LETTER: GOVERNMENT_ICON,
  UTILITY_BILL: UTILITY_ICON,
  NRIC: NRIC_ICON,
  NRIC_BACK: NRIC_BACK_ICON,
  NRIC_PR: NRIC_ICON,
  NRIC_PR_BACK: NRIC_BACK_ICON,
  PAN: PAN_SAMPLE_ICON,
  DRIVING_LICENSE: IN_DRIVING_FRONT_ICON,
  DRIVING_LICENSE_BACK: IN_DRIVING_BACK_ICON,
  PASSPORT: IN_PASSPORT_FRONT_ICON,
  PASSPORT_BACK: IN_PASSPORT_BACK_ICON,
  VOTER_ID: IN_VOTER_FRONT_ICON,
  VOTER_ID_BACK: IN_VOTER_BACK_ICON
};

export const JUMP_TO_MY_INFO = [SCREEN_NAME_PERSONAL_DETAILS];

export const SG_SUBMIT_BUTTON_BASE_STYL = `
font-family: ${FONT_FAMILY.hellix.regular};
font-size: 16px;
font-weight: bold;
font-stretch: normal;
font-style: normal;
line-height: 1.5;
letter-spacing: 1.4px;
text-align: center;
color: ${COLORS.black};
border:none;
`;

export const SSN_TEXT = {
  VERIFY: 'Verify your Identity',
  FRAUD: 'To prevent fraud & safety of money',
  AUTHENTICATE: 'Social Security Number',
  AUTHENTICATION_DETAILS: 'In order to retrieve details, we need your full Social Security number',
  LAST_4_DIGITS: 'Last 4 digits of SSN',
  ENTER_9_DIGITS_SSN: 'Enter your 9 digits of SSN',
  UPLOAD_SOCIAL_SECURITY_CARD: 'Upload Social Security Card',
  IDENTITY:
    'The use of your SSN is a one-time process to verify your identity electronically. Your SSN is secured under data protection regulations.',
  GOVERNMENT:
    'To help the government fight the funding of terrorism and money laundering activities, Federal law requires all financial institutions to obtain, verify, and record information that identifies each person who opens an account.',
  GOVERNMENT_DETAILED_INFO: `To help the government fight the funding of terrorism and money laundering activities, Federal law requires all financial institutions to obtain, verify, and record information that identifies each person who opens an account. What this means for you: When you open an account, we will ask for your name, address, date of birth, and other information that will allow us to identify you. We may also ask to see your driver's license or other identifying documents.`,
  READ_MORE: ` Read more`,
  READ_LESS: ` Read less`,
  HOME: 'Take me to home page',
  ERROR_ATTEMPT1: {
    PRIMARY:
      'We were unable to verify your identity. Please reconfirm your details and re-enter your SSN. You have 1 more attempt.',
    SECONDARY:
      'We are unable to verify your details at this time. Please re-enter your SSN and try again.'
  },
  ERROR_ATTEMPT2: {
    PRIMARY: 'You have exceeded the number of attempts to verify your identity.',
    SECONDARY: 'Please note, you cannot proceed with your registration at this time.'
  },
  SSN_ERROR_DASHBOARD: {
    PRIMARY: 'Your account has been disabled',
    SECONDARY: 'We regret to inform that your account cannot be activated at this time.'
  },
  SSN_ATTEMPT_COUNT_ERROR: `We couldn’t verify some of your details`
};

export const NIUM_FOREX_REASON_FOR_TRANSFER = [
  {
    text: 'University Fee (Overseas Education)',
    value: 'University Fee (Overseas Education)'
  },
  { text: 'Student living expenses', value: 'Student living expenses' },
  { text: 'Tour Remittance', value: 'Tour Remittance' },
  { text: 'Global Conference - MICE', value: 'Global Conference - MICE' },
  {
    text: 'Employment and emigration consultancy fees',
    value: 'Employment and emigration consultancy fees'
  },
  { text: 'Visa Fees', value: 'Visa Fees' },
  {
    text: 'Registration/Subscription/Membership Fees to International Organizations',
    value: 'Registration/Subscription/Membership Fees to International Organizations'
  }
];

export const EU_EXCEPTIONS_COUNTRIES = ['GB', 'NL', 'DE', 'IT'];

export const NIUM_FOREX_THANK_YOU_MESSAGES = [
  'Nium Forex team will contact you in 1-2 business days.',
  'Please check the email you would have received from us with the next steps and documents required to proceed.'
];
export const NIUM_FOREX_DOCS_LIST = {
  'University Fee (Overseas Education)': {
    docsList: [
      'PAN & Aadhar / PP A2 Form (Student Docs - University offer letter, Visa, PP, I20, Bank account details'
    ]
  },
  'Student living expenses': {
    docsList: [
      'PAN & Aadhar / PP A2 Form (Student Docs - University offer letter, Visa, PP, I20, Bank account details'
    ]
  },
  'Tour Remittance': {
    docsList: [
      'PAN & Aadhar / PP A2 Form ( Traveller PP, PAN, Air tickets, Visa copy and Overseas Tour operator Invoice along bank account details)'
    ]
  },
  'Global Conference - MICE': {
    docsList: [
      'Company PAN, GST and Authorised signatory letter along with A2 Form and List of participants with PAN number and PP Numbers list'
    ]
  },
  'Employment and emigration consultancy fees': {
    docsList: [
      'PP, PAN, Visa processing invoice along with bank details and employment offer letter'
    ]
  },
  'Visa Fees': {
    docsList: ['PP, PAN, Visa processing invoice along with bank details.']
  },
  'Registration/Subscription/Membership Fees to International Organizations': {
    docsList: ['PP, PAN and Invoice with overseas bank account details.']
  }
};
export const NIUM_FOREX_FAQ_FORM_URL = 'https://www.instarem.com/policy/IN-NiumForex-FAQs.pdf';
export const NIUM_FOREX_TERMS_CONDITION_URL =
  'https://www.instarem.com/policy/IN-terms-and-conditions.pdf';
export const NIUM_FOREX_SCREENS = [
  {
    name: 'PERSONAL_DETAILS',
    screenName: 'Personal details'
  },
  {
    name: 'CALCULATOR',
    screenName: 'Lock FX rate'
  },
  {
    name: 'BENEFICIARY_DETAILS',
    screenName: 'Recipient details'
  }
];
export const NIUM_FOREX_ALLOWED_BENE_RELATIONSHIP = [
  {
    text: 'Self',
    value: 'Self'
  },
  { text: 'Parents', value: 'Parents' },
  { text: 'Spouse', value: 'Spouse' },
  { text: 'Siblings', value: 'Siblings' }
];

export const NIUM_FOREX_DESCRPTION_TEXT = {
  PERSONAL_DETAILS: 'Tell us about yourself.',
  BENEFICIARY_DETAILS: 'Share recipient details.',
  CALCULATOR: 'Setup a transfer.'
};

export const JPMORGAN_CA = 'JPMORGAN_CA';

export const STRIPE_APPLE_PAY_PAYMENT_METHOD_CODE = 'STRIPE_SG_APPLE_PAY';

export const TRANSFER_METHODS = [
  'CFSB_USD_US_IP',
  'CFSB_USD_US_WT',
  'CFSB_USD_US',
  'PAYNOW_SGD_SG',
  'POLI',
  'DEBIT CARD',
  'PAYID_AUD_AU',
  'EGHL',
  'STRIPE_HK',
  'WORLDPAY',
  'DC_INTERAC_CAD_CA',
  JPMORGAN_CA,
  'STRIPE_EU',
  'STRIPE_UK',
  'CHECKOUT_AU_DEBIT',
  'CHECKOUT_AU_CREDIT',
  'CHECKOUT_US_DEBIT',
  'CHECKOUT_US_CREDIT',
  'STRIPE_SG_DEBIT',
  'STRIPE_SG_CREDIT',
  'FATZEBRA_AU_DEBIT',
  'FATZEBRA_AU_CREDIT',
  STRIPE_APPLE_PAY_PAYMENT_METHOD_CODE
  // NOTE: Add for US FATZEBRA_US_DEBIT and FATZEBRA_US_CREDIT
];
export const OTHER_THAN_BANK_METHODS = [
  'CFSB_USD_US',
  'POLI',
  'EGHL',
  'STRIPE_HK',
  'DEBIT CARD',
  'WORLDPAY',
  'STRIPE_EU',
  'STRIPE_UK',
  'CHECKOUT_AU_DEBIT',
  'CHECKOUT_AU_CREDIT',
  'CHECKOUT_US_DEBIT',
  'CHECKOUT_US_CREDIT',
  'STRIPE_SG_DEBIT',
  'STRIPE_SG_CREDIT',
  'FATZEBRA_AU_DEBIT',
  'FATZEBRA_AU_CREDIT',
  STRIPE_APPLE_PAY_PAYMENT_METHOD_CODE
  // NOTE: Add for US FATZEBRA_US_DEBIT and FATZEBRA_US_CREDIT
];
export const BANK_METHODS = [
  'CFSB_USD_US_WT',
  'CFSB_USD_US_IP',
  'PAYID_AUD_AU',
  'PAYNOW_SGD_SG',
  'DC_INTERAC_CAD_CA',
  JPMORGAN_CA
];

//New Flow Acknowledgement Notes
export const GEO_SWIFT_NOTES = [
  'Based on the recipient’s Geoswift registration and time of transaction acceptance, receiving amount may vary as per the conversion rate of that particular time.',
  'After your payment to Instarem, Please remind your recipient to register on Geoswift and accept the transaction within 48 hrs to avoid rejection.'
];

export const ACKNOWLEGEMNT_NOTES = {
  PAYNOW: {
    TOPHEADING: 'Pay using PayNow',
    QR_CODE_TEXT1: [
      'The QR code is valid only for this particular transaction. ',
      'On scanning the QR code, amount and reference number will be auto-filled.'
    ],
    QR_CODE_TEXT: 'Click to download QR code',
    SUBHEADING:
      'Pay to following Instarem bank account using PayNow. Ensure that your bank is enabled for PayNow. '
  },
  PAYID: {
    TOPHEADING: 'Pay using PayID',
    SUBHEADING:
      'To pay, login to your bank internet banking account or mobile app, select PayID (also known as ‘Pay anyone’, ‘Pay someone’) and enter below PayID.',
    SUBHEADING1: ['PayID details have also been sent to your registered email ID.']
  },
  CFSB_USD_US: {
    TOPHEADING: 'ACH payment is initiated.',
    SUBHEADING1: [
      'Funds will usually be debited from your bank account within 1 business day.',
      'Once debited, the amount is usually processed in 1-2 business days.'
    ]
  },
  BANK_TRANSFER: {
    TOPHEADING: 'Pay using Bank Transfer',
    SUBHEADING:
      "Login to your bank's website and transfer the funds to following Nium bank account."
  },
  DC_INTERAC_CAD_CA: {
    TOPHEADING: 'Pay using INTERAC e-Transfer',
    SUBHEADING:
      "Log in to your financial institution's online or mobile banking and navigate to Interac e-Transfer Send Money."
  },
  JPMORGAN_CA: {
    TOPHEADING: 'Pay using Bank Transfer (EFT)',
    SUBHEADING:
      "Log in to your financial institution's online or mobile banking and transfer the funds to following Nium bank account."
  },
  POLI: {
    TOPHEADING: 'Your transfer has been initiated.',
    SUBHEADING1: [
      'It may take longer than usual for the money to reach us.',
      'Once we receive your funds, the transfer will usually be processed in 1 business day.'
    ]
  },
  EGHL: {
    TOPHEADING: 'Your transfer has been initiated.',
    SUBHEADING1: [
      'It may take longer than usual for the money to reach us.',
      'Once we receive your funds, the transfer will usually be processed in 1 business day.'
    ]
  },
  WORLDPAY: {
    TOPHEADING: 'Your transfer has been initiated.',
    SUBHEADING1: [
      'It may take longer than usual for the money to reach us.',
      'Once we receive your funds, the transfer will usually be processed in 1 business day.'
    ]
  },
  TRANSACTION_CANCEL: {
    TOPHEADINGAU: 'POLi payment failed.',
    TOPHEADINGMY: 'FPX payment failed.',
    TOPHEADINGHK: 'Payment failed.',
    TOPHEADING_CARD: 'Payment failed.',
    SUBHEADING1: 'Please contact your bank for more information.',
    SUBHEADING2: 'If you need our assistance visit '
  },
  STRIPE_HK: {
    TOPHEADING: 'Payment received',
    SUBHEADING1: ['Your transaction will be processed soon.']
  },
  STRIPE_EU: {
    TOPHEADING: 'Payment received',
    SUBHEADING1: ['Your transaction will be processed soon.']
  },
  STRIPE_UK: {
    TOPHEADING: 'Payment received',
    SUBHEADING1: ['Your transaction will be processed soon.']
  },
  STRIPE_SG_DEBIT: {
    TOPHEADING: 'Payment received',
    SUBHEADING1: ['Your transaction will be processed soon.']
  },
  STRIPE_SG_CREDIT: {
    TOPHEADING: 'Payment received',
    SUBHEADING1: ['Your transaction will be processed soon.']
  },
  CHECKOUT_AU_DEBIT: {
    TOPHEADING: 'Payment received',
    SUBHEADING1: ['Your transaction will be processed soon.']
  },
  CHECKOUT_AU_CREDIT: {
    TOPHEADING: 'Payment received',
    SUBHEADING1: ['Your transaction will be processed soon.']
  },
  CHECKOUT_US_DEBIT: {
    TOPHEADING: 'Payment received',
    SUBHEADING1: ['Your transaction will be processed soon.']
  },
  CHECKOUT_US_CREDIT: {
    TOPHEADING: 'Payment received',
    SUBHEADING1: ['Your transaction will be processed soon.']
  },
  FATZEBRA_AU_CREDIT: {
    TOPHEADING: 'Payment received',
    SUBHEADING1: ['Your transaction will be processed soon.']
  },
  FATZEBRA_AU_DEBIT: {
    TOPHEADING: 'Payment received',
    SUBHEADING1: ['Your transaction will be processed soon.']
  },
  // NOTE: Add for US FATZEBRA_US_DEBIT and FATZEBRA_US_CREDIT
  'DEBIT CARD': {
    TOPHEADING: 'Payment received.',
    SUBHEADING1: ['Your transaction will be processed soon.']
  },
  REQUEST_STATUS: {
    FAIL: 'Payment failed',
    REQUESTSUBMIT: 'Payment request submitted!',
    INITIATED: 'Payment initiated',
    RECIEVED: 'Payment received'
  },
  STATUS: {
    FAILED: 'Cancelled',
    INPROCESS: 'Payment in process',
    INPROCESSDOTS: 'Payment in process...',
    PROCESSED: 'Processing',
    AWAITING: 'Awaiting payment'
  },
  STATUS_COLOR: {
    CANCELLED: 'red',
    AWAITING_PAYMENT: '#FF8D1E',
    FAILED: 'red',
    PAID: 'green',
    DEFAULT: '#5BA2F8'
  }
};

export const APPLE_PAY_TXN_STATUS_CONTENT = {
  FAILED: {
    TOPHEADING: 'Payment failed'
  },
  PAID: {
    TOPHEADING: 'Payment received'
  },
  AWAITING_PAYMENT: {
    TOPHEADING: 'Payment pending'
  }
};

export const TRANSACTION_TIMELINE_CONTENT = 'May vary subject to our terms and conditions.';
export const TRANSACTION_TIMELINE_SUBCONTENT = 'Time estimated from receipt of your funds';

export const SSN_REKYC_PATH = [
  PAYEE_LIST_URL,
  HISTORY_URL,
  INSTAPOINTS_URL,
  REFERRAL_URL,
  ADD_PAYEE_URL,
  USER_PROFILE_URL,
  TRANSFER_MONEY_URL
];

export const ALL_ACCOUNT_TYPES = [INDIVIDUAL, CORPORATE];
export const MONEYGRAM_CASH_PAYOUT = 'MONEYGRAM_CASH_PAYOUT';
export const TOGGLE_FEATURE_COUNTRY_CODE = ['US', 'SG', 'AU', 'HK', 'MY', 'IN', 'CA', ...EU_REGION];
export const TOGGLE_FEATURE_OFF_FOR_REGISTRATION_FLOW = ['AU', 'MY', ...EU_REGION];
export const NEW_FLOW_NO_MOBILE_VERIFICATION = [...EU_REGION];
export const TOGGLE_FEATURE_ON_FOR_REGISTRATION_FLOW = [];
export const CASH_PAYOUT = 'CASH_PAYOUT';
export const ONBOARDING_ACK_SCREENS = ['SG', 'IN', 'CA'];
export const US = 'US';
export const HK = 'HK';
export const SG = 'SG';
export const AU = 'AU';
export const CA = 'CA';
export const UK = 'UK';
export const INR = 'INR';
export const PH = 'PH';
export const JP = 'JP';

export const MOBILE_EMAIL_OTP_MSG =
  'We have sent you a 6-digit code to your registered mobile number and email used with this account';
export const EMAIL_OTP_MSG = 'We sent a 6-digit code to your email ID';

export const UtilityContentMsg = 'As per your recipient’s bank statement or utility bill';

export const CARD_ICON = {
  VISA: ADD_VISA_ICON,
  MASTERCARD: MASTERCARD_ICON,
  DISCOVER: DISCOVER_ICON,
  AMERICAN_EXPRESS: AMEX_ICON,
  AMEX: AMEX_ICON,
  AMEX_LITE: AMEX_LITE_ICON,
  VISA_LITE: VISA_SVG_ICON,
  MASTERCARD_LITE: MASTERCARD_LITE_ICON,
  DISCOVER_LITE: DISCOVER_LITE_ICON,
  AMERICAN_EXPRESS_LITE: AMEX_LITE_ICON
};

export const infoPoints = {
  POI: {
    DEFAULT: [
      { text: 'Should be visible & clearly readable', type: 'accept' },
      { text: 'We accept digital or scanned copy', type: 'accept' },
      { text: 'Can’t be cropped or blurry', type: 'reject' },
      { text: 'No photo or copy of a photocopy', type: 'reject' }
    ]
  },
  POA: {
    DEFAULT: [
      { text: 'Preferred downloaded PDF', type: 'accept' },
      {
        text: 'Recent document in valid period of latest 90 days',
        type: 'accept'
      },
      { text: 'Must reflect your name', type: 'accept' },
      { text: 'Should match with address provided', type: 'accept' },
      { text: 'Should be visible & clearly readable', type: 'accept' },
      { text: 'Can’t be cropped or blurry', type: 'reject' }
    ],
    IN: [
      { text: 'Document should be self attested by you', type: 'accept' },
      { text: 'Must reflect your name', type: 'accept' },
      { text: 'Should match with address provided', type: 'accept' },
      { text: 'Should be visible & clearly readable', type: 'accept' },
      { text: 'Can’t be cropped or blurry', type: 'reject' }
    ]
  },
  PERSONAL_IMAGE: {
    DEFAULT: [
      { text: 'Face should be clearly visible', type: 'accept' },
      { text: 'Document clearly visible', type: 'accept' },
      { text: 'Face & ID should be in one Picture', type: 'accept' }
    ]
  }
};

export const IN_POA_FRONT_DOCS = [
  'INDIVIDUAL_POA.DRIVING_LICENSE.individual_poa_driving_license_doc_file',
  'INDIVIDUAL_POA.VOTER_ID.individual_poa_voter_id_doc_file',
  'INDIVIDUAL_POA.PASSPORT.individual_poa_passport_doc_file'
];

export const PI_form_disable_country_code = ['SG', 'IN'];

export const APP_URL = {
  ANDROID: 'https://play.google.com/store/apps/details?id=com.instarem.mobileapp&hl=en',
  APPLE: 'https://apps.apple.com/in/app/instarem-send-money-overseas/id1190075959',
  COMMON: 'https://www.instarem.com/getapp',
  TRUSTPILOT: 'https://www.trustpilot.com/review/instarem.com'
};

export const APP_URL_ONELINK = 'https://myappdownload.onelink.me/C74i/msitepup';
//Images
export const Images = {
  MY_INFO_MOBILE_LOGO: MY_INFO_MOBILE_ICON,
  MY_INFO_WEB_LOGO: FLOATING_LABEL_MY_INFO_ICON,
  NOTIFICATION_BELL_ICON_SBM: NOTIFICATION_ICON_SBM_ICON,
  MY_ACCOUNT_SETTINGS_ICON_SBM: MY_ACCOUNT_SBM_ICON
};

export const VISA_TNC_LINK = 'info/all-policies';

export const VISA_FAQ_LINKS = {
  SG: '/en-sg/help-and-support#visadirect',
  HK: '/en-hk/help-and-support#visadirect',
  AU: '/en-au/help-and-support#visadirect'
};
export const JUMIO_ENABLE_COUNTRY = ['MY', 'HK', 'SG'];

export const JUMIO_AVAILABLITY_CHECK_COUNTRY = ['HK', 'SG'];
//Flags

export const FLAG_URL = 'https://cdn.instarem.com/images/flags/';
export const BASE_CDN_IMAGE_URL = 'https://cdn.instarem.com/images/consumer';

// instarem_bank_account

export const BANK_TRANSFER = 'BANK TRANSFER';
export const DEBIT_CARD = 'DEBIT CARD';
export const LINKED_BANK_ACCOUNT = 'LINKED BANK ACCOUNT';
export const PAY_TO = 'PAYTO TRANSFER';

//beneficiary_routing_config

export const BRANCH_NAME = 'BRANCH NAME';
export const BANK_NAME = 'BANK NAME';
export const ACCOUNT_NUMBER = 'ACCOUNT NUMBER';
export const ACCOUNT_NO_CHANGE_WARNING = `Our bank account number has been updated – 
  please be sure to use this one while making your payment`;
export const BANK_DETAILS_CHANGE_WARNING = `We have updated our banking details – 
please make sure to use the updated information when making your payment.`;

// transaction_status

export const AWAITING_PAYMENT_STATUS = 'AWAITING PAYMENT';

export const BRANCH_NAME_COUNTRIES = [
  {
    currencyCode: 'BDT',
    bankAccountCountry: 'BD',
    accountType: ['INDIVIDUAL', 'CORPORATE']
  },
  {
    currencyCode: 'GHS',
    bankAccountCountry: 'GH',
    accountType: ['INDIVIDUAL', 'CORPORATE']
  },
  {
    currencyCode: 'KES',
    bankAccountCountry: 'KE',
    accountType: ['INDIVIDUAL', 'CORPORATE']
  },
  {
    currencyCode: 'UGX',
    bankAccountCountry: 'UG',
    accountType: ['INDIVIDUAL', 'CORPORATE']
  },
  {
    currencyCode: 'TZS',
    bankAccountCountry: 'TZ',
    accountType: ['INDIVIDUAL', 'CORPORATE']
  }
];

export const AFRICAN_PAYOUTS_BENE_NAME_VALIDATION_CURRENCIES = [
  'ZAR',
  'GHS',
  'TZS',
  'NGN',
  'KES',
  'UGX'
];

export const BENE_SERVICE_CONFIG = [
  {
    country_code: 'BR',
    currency_code: 'BRL'
  },
  {
    country_code: 'AR',
    currency_code: 'ARS'
  }
];

export const PROCESSING_ACKNOWLEDGE = {
  APPROVED: {
    title: 'Account verified',
    icon: APPROVED_ICON,
    SubText: {
      text1: '',
      text2: 'Now you can start transferring money to your recipient!',
      text3: 'Get me Amaze',
      text4: ''
    }
  },
  AWAITING: {
    title: 'Your profile is under review',
    icon: ACK_SEARCH_ICON,
    SubText: {
      text1: 'You will be notified within 24 hrs.',
      text2: 'Meanwhile add your recipient to expedite the process of money transfer',
      text3: 'Go to home screen.',
      text4:
        'You’ll be notified as soon as your account gets approved, you can then start transferring without further ado!'
    }
  },
  RECIPIENT_AFTER_TEXT: {
    title: 'Allow us 24 hrs to review your profile',
    icon: RECIPIENT_ICON,
    SubText: {
      text1: '',
      text2:
        'You’ll be notified as soon as your account gets approved, you can then start transferring without further ado!',
      text3: '',
      text4: ''
    }
  },
  PROCESSING: {
    title: '',
    icon: PROCESSING_ICON,
    SubText: {
      text1: '',
      text2: 'Processing...',
      text3: 'This will take only a few seconds',
      text4: ''
    }
  }
};
export const NEW_KYC_ONBOARDING_FLOW = ['SG'];

export const NEW_KYC_FLOW_CONTENT = {
  [REGISTERED]: {
    title: 'Verify Account',
    description: 'To start sending money'
  },
  [INITIATED]: {
    title: 'Complete your Verification',
    description: 'To start sending money'
  }
};

export const SPLIT_KYC_ON = 'OPTION_1';
export const APP_ONLY_CORRIDORS_FLAG = 'app_only_corridors';
export const MANAGE_PAYMENT_OPTION_FLAG = 'manage_payment_options';
//Add card modal content
export const ADD_CARD_MODAL_CONTENT = {
  DEBIT: {
    heading: 'Debit card',
    subHeading: 'Select from saved card',
    addNote: 'Add new debit card'
  },
  CREDIT: {
    heading: 'Credit card',
    subHeading: 'Select from saved card',
    addNote: 'Add new credit card'
  }
};

export const MAX_LIMIT_NOTES = {
  DEBIT:
    'You have exceeded the maximum number of add cards. Remove added debit card to add a new one.',
  CREDIT:
    'You have exceeded the maximum number of add cards. Remove added credit card to add a new one.'
};
export const REFFERAL_TEXT = {
  amaze: 'when they make their first transfer or transact',
  amaze2: 'with amaze card',
  default: 'when they make their first transfer'
};

export const AMAZE_ID = '3_';
//post logout localstorage key
export const POST_LOGOUT = 'POST_LOGOUT';

export const FATZEBRA_LOADER_FLAG = 'fatzebra_loader';

export const BENE_SCHEMA_ENABLE_FLAG = 'bene_service_schema_enable_country_currency';
export const BENEFICIARY_FLOW_PAYOUT_METHODS = 'beneficiary_flow_payout_methods';
//transfer methods
export const POLI_TRANSFERS = ['POLI'];
export const CARD_TRANSFERS = [
  'STRIPE_HK',
  'STRIPE_UK',
  'STRIPE_EU',
  'CHECKOUT_AU_DEBIT',
  'CHECKOUT_AU_CREDIT',
  'CHECKOUT_US_DEBIT',
  'CHECKOUT_US_CREDIT',
  'STRIPE_SG_DEBIT',
  'STRIPE_SG_CREDIT',
  'FATZEBRA_AU_DEBIT',
  'FATZEBRA_AU_CREDIT'
  // NOTE: Add for US FATZEBRA_US_DEBIT and FATZEBRA_US_CREDIT
];
export const PAYID_TRANSFERS = ['PAYID_AUD_AU'];
export const EGHL_TRANSFERS = ['EGHL'];
export const WORLDPAY_TRANSFERS = ['WORLDPAY'];
export const PAYNOW_TRANSFER = ['PAYNOW_SGD_SG'];
export const ACH_TRANSFERS = ['CFSB_USD_US'];
export const APPLE_PAY_TRANSFERS = [STRIPE_APPLE_PAY_PAYMENT_METHOD_CODE];

export const FACEBOOK_SOCIAL_SIGN_IN_FEATURE_FLAG = 'facebook_social_signin_disable';
//AMAZE
export const IS_AMAZE = ['SG'];

//Flagsmith keys
export const FEATURE_DISCOVERY_NEW_PAYMENT_METHOD = 'feature_discovery_new_payment_method';
export const SHOW_FEE_DIFFERENCE = 'show_fee_difference';
export const APP_RATING = 'onboarding_rating';
export const RECURRING_TRANSFER = 'recurring_transfer';
export const NIUM_FOREX_FLAG = 'nium_forex_enabled_users';
export const KRISFLYER_MILES_WEB = 'krisflyer_miles_web';
export const DISABLED_PAYMENTS_METHODS = 'disabled_payment_methods';
export const GET_SME_USER_COUNTRY_LIST_TO_MIGRATE = 'sme_country_migrate_list';
export const SUPPORTED_BANKS_THB = 'thb_supported_banks';
export const COLLECT_BANK_ACCOUNT_TYPE = 'collect_bank_account_type';

//Advertise Flagsmith keys
export const ADVERTISE_FLAGSMITH_KEYS = [
  {
    key: 'advertise_forex_card',
    id: 'forex',
    consent_id: 'is_user_interested_for_forex'
  }
];

export const PAYMENT_ADVERTISING_FLAGSMITH_KEYS = [
  {
    key: 'advertise_new_payment_methods',
    id: 'debit/credit',
    cmsData: {
      AU: {
        content_type: 'advertisement',
        title: 'AU_ADVERTISEMENT'
      },
      US: {
        content_type: 'advertisement',
        title: 'US_ADVERTISEMENT'
      }
    }
  }
];

export const CONTENTFUL_SCHEMA_KEYS = {
  REFER_N_EARN: {
    CONTENT_TYPE: 'pageInviteEarn',
    TITLE: 'INVITE_EARN'
  }
};

export const INSTA_MODAL_SESSION_KEY = 'InstaModal';

//App Download Promotion
export const NEVER_SHOW = 'Download-Popup';
//TICKET STATUS
export const TICKET_FILTER = ['All', 'Open', 'Resolved'];

//TICKET STATUS CODE
export const TICKET_STATUS_CODE = { Open: 2, Resolved: 5 };

export const CORPORATE_CUSTOMER_SUPPORT_EMAIL = 'bizsupport@instarem.com';
export const TICKET_CREATION_FAILED = 'Failed to create ticket for your enquiry. Please try again';
export const NOTE_IS_REQUIRED = 'Note is required';
export const FILE_SIZE_LIMIT = 5;
export const FILE_COUNT_LIMIT = 4;
export const FILE_COUNT_LIMIT_ERROR = `Only ${FILE_COUNT_LIMIT} items can be attached at once`;
export const SAME_FILE_ERROR = `Duplicate files are not allowed`;
export const TICKET_SOURCE = { OUTBOUND_EMAIL: 'OUTBOUND_EMAIL', CHAT: 'CHAT' };
export const TICKET_SOURCE_CHAT_HEADING = 'Chat history with Instarem';
//Add cards fields
export const ADD_CARD_FIELDS = ['card_number', 'name_on_card', 'expiry_date', 'cvc'];

export const FEEDBACK_CONTENT = {
  RATE_CARD: {
    title: 'Rate your onboarding',
    content: 'How did you find your onboarding experience?'
  },
  TRANSACTION_RATE_CARD: {
    title: 'How was this transfer?',
    content: 'You sent {AMOUNT} SGD to {BENE_NAME}'
  },
  REFUND_RATE_CARD: {
    title: 'Rate your refund experience',
    content: 'You were refunded {AMOUNT} for transfer to {BENE_NAME}'
  },
  POSITIVE_DATA_CARD: {
    trustpilotcontent: 'Whoa, thanks! Mind spreading the word?',
    trustpilotbutton: 'Rate Instarem on Trustpilot',
    invitecontent: 'Thanks! Spread the word to earn {INSTAPOINTS}IPs!',
    invitebutton: 'Invite friends'
  },
  THANKYOU_CARD: {
    title: 'Thank you!',
    content_1: 'Spread the word by adding a review on Trustpilot.',
    content_2:
      'We value your feedback and we’ll do our best to make your next Instarem experience better. ',
    content_3:
      'We’re happy that you enjoyed your Instarem experience. We are working at making it even better!',
    button: 'Add review'
  },
  FEEDBACK_TAGS_CARD: {
    title: 'What went wrong?',
    content: 'Select all that that you didn’t like about your onboarding experience',
    button: 'Submit feedback'
  }
};

export const UTM_CAMPAIGNING = 'utm_campaigning';

export const CATEGORY = {
  EARNED: 'EARNED',
  REDEEMED: 'REDEEMED',
  REFERRED: 'REFERRED',
  EXPIRED: 'EXPIRED',
  REVERSED: 'REVERSED',
  REFUNDED: 'REFUNDED',
  REVERTED: 'REVERTED'
};

export const SINGPASS_NAME_EDIT = {
  editNameModalCTA: 'My name is in the wrong order',
  heading: 'Edit your name',
  subHeading: 'Assign each name a category to proceed',
  categoryHeadings: ['First name', 'Middle name (optional)', 'Last name'],
  confirmButtonMsg: 'Confirm name',
  errorMsg: {
    firstNameError: 'First name can’t be empty',
    lastNameError: 'Last name can’t be empty'
  },
  defaultEmptyMsg: 'No names left to add to this category'
};

export const EARN_CARDS_DATA_DEFAULT_SCHEMA = [
  {
    cardImgUrl: CARD_ICON_AMAZE_CARD,
    cardHeading: 'Get amaze card',
    cardDescription: 'Earn InstaPoints and convert them to cash rewards.',
    btnLabel: 'Get amaze card',
    redirectLink: `${BASE_URL}/amaze`,
    supportingCountries: ['SG'],
    earnType: 'get_amaze'
  },
  {
    cardImgUrl: CARD_ICON_AMAZE_CARD,
    cardHeading: 'Spend with amaze',
    cardDescription: 'Earn 1 IP for every 1 SGD spent overseas. T&Cs apply. ',
    btnLabel: 'Go to amaze',
    redirectLink: `${BASE_URL}/amaze`,
    supportingCountries: ['SG'],
    earnType: 'go_to_amaze'
  },
  {
    cardImgUrl: CARD_ICON_TRANSFER_OVERSEAS,
    cardHeading: 'Transfer overseas',
    cardDescription: 'Earn InstaPoints on every transfer.',
    btnLabel: 'Send now',
    redirectLink: `${BASE_URL}/transfer-money`,
    supportingCountries: ['ALL'],
    earnType: 'send_now'
  },
  {
    cardImgUrl: CARD_ICON_INVITE,
    cardHeading: 'Invite a friend',
    cardDescription: 'Get {REFERRAL_POINTS} IPs when your friend transfers with us.',
    btnLabel: 'Invite friends',
    redirectLink: `${BASE_URL}/referrals`,
    supportingCountries: ['ALL'],
    earnType: 'invite_friends'
  }
];

export const AMAZE_BANNER_DATA_DEFAULT_SCHEMA = {
  bannerHeading: 'Earn cashback with amaze',
  bannerDescription:
    'Download the Instarem app and get amaze to earn 20 SGD cashback in exchange for 2000 IPs.',
  bannerImgWebView: `${BASE_CDN_IMAGE_URL}/amaze-banner-card.svg`,
  bannerImgMobileView: `${BASE_CDN_IMAGE_URL}/amaze-banner-card-mobile.svg`,
  btnLabel: 'Get Instarem app'
};

export const KRISFLYER_MILES_WEB_SCHEMA = {
  bannerHeading: 'Earn KrisFlyer miles with amaze',
  bannerHeading2: 'Earn KrisFlyer with amaze',
  bannerDescription:
    'Download the Instarem app and get amaze to earn 1 KrisFlyer mile in exchange for 3 InstaPoints.',
  btnLabel: 'Get Instarem app'
};

export const IP_DOWNLOAD_APP_MODAL = {
  heading: 'Get Instarem app',
  description: 'Scan with your mobile phone camera and click on the link that appears.',
  btnLabel: 'Dismiss'
};
export const IP_DOWNLOAD_APP_MODAL_MOBILE = {
  heading: 'Get Instarem app',
  description:
    'Earn cashback with amaze and enjoy quick & easy money transfers at your fingertips.',
  btnLabel: 'Dismiss'
};
export const INSTA_POINT_HISTORY = {
  earned: 'Earned',
  redeemed: 'Redeemed',
  referred: 'Referred',
  expired: 'Expired',
  reversed: 'Reversed',
  details: 'Details',
  debited: 'Debited',
  credited: 'Credited',
  expiresOn: 'Expires on',
  expiredOn: 'Expired on',
  redeem: 'Redeem',
  pendingTransfer: 'Pending transfer',
  earnInstaPoint: 'Earn InstaPoints',
  expiringSoon: 'Expiring soon',
  instapointHistory: 'InstaPoints history',
  instaPointsID: 'InstaPoints ID',
  txnID: 'Transaction ID',
  instaPointsUsed: 'InstaPoints used',
  instaPointsOnHold: 'InstaPoints on hold',
  instaPointsEarned: 'InstaPoints earned',
  instaPointsDebited: 'InstaPoints debited',
  instaPointsExpired: 'InstaPoints expired',
  instaPointsCredited: 'InstaPoints credited',
  instaPointsRedeemed: 'InstaPoints redeemed',
  instaPointsReversed: 'InstaPoints reversed',
  cashbackEarned: 'Cashback earned',
  instaPointsHistory: 'InstaPoints history',
  expiryForEarnedPoints: 'Expiry for earned points',
  discountFromUsedPoints: 'Discount from used points',
  balance: 'Balance',
  thisMonth: 'This month',
  usedLabel: '(used)',
  earnedLabel: '(earned)',
  ipsEarned: 'IPs earned',
  ipsExpiring: 'IPs expiring',
  instaPointsTitle: 'InstaPoints',
  activity: 'Activity',
  debit: 'Debit',
  credit: 'Credit',
  transfer: 'Transfer',
  amazeSpend: 'Amaze spend',
  redemption: 'Redemption',
  krisflyerMilesText: 'KrisFlyer Miles',
  pointsExpiration: 'Points expiration',
  signUp: 'Sign-up',
  accountVerification: 'Account verification',
  debitAdjustment: 'Debit adjustment',
  creditAdjustment: 'Credit adjustment',
  reversalOnTransfer: 'Reversal on transfer',
  reversalOnAmaze: 'Reversal on amaze',
  referralbonus: 'Referral bonus',
  promotion: 'Promotion',
  refundOnExcessAmount: 'Refund on excess amount',
  getAmaze: 'Get amaze',
  loadMore: 'Load more',
  ipLabel: 'IPs',
  sendMoney: 'Send money',
  instaPointsIdCopied: 'InstaPoints ID copied',
  txnIdCopied: 'Transaction ID copied',
  referralFrom: 'Referral from',
  referralTo: 'Referral to',
  expiryForCreditedPoints: 'Expiry for credited points',
  instaPointsRefunded: 'InstaPoints refunded',
  refreeRefunded: 'Reversal of referral IPs',
  referrerReverted: 'Reversal of referral IPs',
  amazeSuccessScreenLabel: {
    gotIt: 'Got it',
    hooray: 'Hooray!',
    youGot: 'You got',
    redeemed: 'Redeemed:',
    newBalance: 'New balance:',
    remainingBalance: 'Remaining balance:',
    instaPointsRedeem: 'InstaPoints redeemed'
  },
  walletLimitError:
    "Can't redeem {IP_BALANCE} IPs as your wallet balance will exceed the {WALLET_LIMIT_CURRRENCY} limit with this redemption."
};

export const ENTITY_TYPE = {
  TRANSACTION_PENDING: 'TRANSACTION_PENDING',
  TRANSACTION_EARNED: 'TRANSACTION_EARNED',
  TRANSACTION_REDEMPTION: 'TRANSACTION_REDEMPTION',
  PROMOTION: 'PROMOTION',
  TRANSACTION_REFERRAL: 'TRANSACTION_REFERRAL',
  INITIAL_REFERRAL: 'INITIAL_REFERRAL',
  EXCESS_FUND_TRANSACTION: 'EXCESS_FUND_TRANSACTION',
  TRANSACTION_REVERSAL: 'TRANSACTION_REVERSAL',
  AMAZE_TRANSACTION_REVERSAL: 'AMAZE_TRANSACTION_REVERSAL',
  ADJUSTMENT: 'ADJUSTMENT',
  PROFILE_COMPLETE_PROMOTION: 'PROFILE_COMPLETE_PROMOTION',
  TRANSACTION_REFUND_SETTLEMENT: 'TRANSACTION_REFUND_SETTLEMENT',
  WELCOME: 'WELCOME',
  AMAZE_TRANSACTION_EARNED: 'AMAZE_TRANSACTION_EARNED',
  AMAZE_CASHBACK_REDEMPTION: 'AMAZE_CASHBACK_REDEMPTION',
  INITIAL_PARTNER_REFERRAL: 'INITIAL_PARTNER_REFERRAL',
  AMAZE_KRISFLYER_REDEMPTION: 'AMAZE_KRISFLYER_REDEMPTION'
};

export const IP_HISTORY_PAGE_SIZE = 20;
export const DEFAULT_SCHEMA = 'DEFAULT';

export const CARDS_DATA = {
  SEND_MONEY: {
    title: 'Send money overseas',
    description: `Fast, easy and secure money transfers to 50+ countries.`,
    btnName: 'Send money'
  },
  AMAZE: {
    title: 'Get your amaze card',
    description: 'Stack up rewards and declutter your wallet with a single card.',
    btnName: 'Know more'
  }
};
export const INSTAREM_APP_MIGRATION_ONE_LINK = 'https://instarem.onelink.me/EX7E/apppricing';
export const FEEDBACK_CARD = {
  RATE_INTERACTION: {
    heading: 'Rate your interaction',
    subHeading: 'Are you happy with the service you received?'
  },
  RATE_CARD: {
    subText1: 'Select all that you liked about your help centre experience',
    subText2: 'Select all that you didn’t like about your support experience',
    placeholder: 'Anything you want to add (optional)'
  },
  THANKYOU_CARD: {
    thankyou: 'Thank you!',
    positiveMessage:
      'We’re happy that you enjoyed your Instarem experience. We are working to make it even better!',
    negativeMessage:
      'We value your feedback and we’ll do our best to make your next Instarem experience better.',
    referFriend: 'Refer a friend',
    rateOnTrustPilot: 'Rate Instarem on Trustpilot'
  },
  BUTTONS: {
    submit: 'Submit feedback',
    dismiss: 'Dismiss'
  }
};
export const NEWAUTHSCREEN = {
  troubleLoggingText: 'I have trouble logging in',
  passwordResetText: 'Password has been reset.',
  useNewPassowrdText: 'Kindly use new password for log-in.',
  reviewAndAcceptText: 'You need to review and accept our T&C to proceed',
  signUpHereText: 'Sign up here',
  logInHereText: 'Log in here',
  alreadySignedUpText: 'Already signed up?',
  newToInstarem: 'New to Instarem?'
};
export const TROUBLESHOOT_LOGIN = {
  forgotPasswordText: 'I forgot my password',
  otpNotReceived: 'I didn’t receive an OTP',
  otherIssuesText: 'Other issue'
};

export const FEEDBACK_REASON_NPS_SURVEY = 'nps-survey';
export const INSTAREM_APP_DOWNLOAD_LINK = 'https://go.onelink.me/DA5n/cba76eec';

export const NEW_ONBOARDING_FLOW_COUNTRY_LIST = [
  {
    name: 'Australia',
    code: 'AU'
  },
  {
    name: 'Malaysia',
    code: 'MY'
  },
  {
    name: 'France',
    code: 'FR'
  },
  {
    name: 'Austria',
    code: 'AT'
  },
  {
    name: 'Belgium',
    code: 'BE'
  },
  {
    name: 'Bulgaria',
    code: 'BG'
  },
  {
    name: 'Cyprus',
    code: 'CY'
  },
  {
    name: 'Croatia',
    code: 'HR'
  },
  {
    name: 'Denmark',
    code: 'DK'
  },
  {
    name: 'Czech Republic',
    code: 'CZ'
  },
  {
    name: 'Estonia',
    code: 'EE'
  },
  {
    name: 'Finland',
    code: 'FI'
  },
  {
    name: 'Germany',
    code: 'DE'
  },
  {
    name: 'Greece',
    code: 'GR'
  },
  {
    name: 'Hungary',
    code: 'HU'
  },
  {
    name: 'Iceland',
    code: 'IS'
  },
  {
    name: 'Ireland',
    code: 'IE'
  },
  {
    name: 'Italy',
    code: 'IT'
  },
  {
    name: 'Latvia',
    code: 'LV'
  },
  {
    name: 'Liechtenstein',
    code: 'LI'
  },
  {
    name: 'Malta',
    code: 'MT'
  },
  {
    name: 'Netherlands',
    code: 'NL'
  },
  {
    name: 'Norway',
    code: 'NO'
  },
  {
    name: 'Poland',
    code: 'PL'
  },
  {
    name: 'Portugal',
    code: 'PT'
  },
  {
    name: 'Romania',
    code: 'RO'
  },
  {
    name: 'Slovakia',
    code: 'SK'
  },
  {
    name: 'Slovenia',
    code: 'SI'
  },
  {
    name: 'Spain',
    code: 'ES'
  },
  {
    name: 'Sweden',
    code: 'SE'
  },
  {
    name: 'United Kingdom',
    code: 'GB'
  },
  {
    name: 'Lithuania',
    code: 'LT'
  },
  {
    name: 'Monaco',
    code: 'MC'
  },
  {
    name: 'San Marino',
    code: 'SM'
  },
  {
    name: 'Luxembourg',
    code: 'LU'
  }
];

export const SIGNUP_ERROR_MSG =
  'Min. 8 characters, one upper & lowercase, one number, one special character.';

export const SIGNIN_META_TITLE = 'Instarem - Sign In To Your Account';
export const SIGNIN_META_DESC =
  'Log in to Instarem to manage your international transfers, track payments, and enjoy competitive rates.';
export const SIGNUP_META_TITLE = 'Instarem - Create Your Account Today';
export const SIGNUP_META_DESC =
  'Register with Instarem to start sending money abroad with ease. Enjoy low fees, excellent rates, and fast transactions.';
export const OTHERS_META_TITLE = 'Instarem - Money Simple';
export const OTHERS_META_DESC =
  'Experience money made simple with Instarem. Enjoy smarter, faster, and affordable cross-border transfers without unfair rates or hidden fees for peace of mind.';

export const DASHBOARD = {
  documentReviewMsgIndiaText: `Our team is reviewing your account details. We'll get back to you at the earliest.`,
  documentReviewMsgUSAText: `We are reviewing your details and your account will be approved within few hours.`,
  documentReviewMsgOTHERSText: `Our team is reviewing the documents you have submitted. We'll get back to you at the earliest.`,
  provideInformation: 'Provide Information',
  REACKNOWLEDGED: {
    documentReviewMsg: `Don't worry! Your account is temporarily paused. We’re reviewing your profile. Please check back later.`,
    rfiRequired: `Don't worry! Your account is temporarily paused. We need some information to reinstate it. Provide the details, and we'll get you going quickly! `
  },
  REJECTED: {
    riskRejectedText: `As per our internal policy we regret that we are unable to proceed with your registration.`,
    thankyouText: `Thank you for your application and interest in Instarem. We regret to inform that your account cannot be activated as per our internal policies.`
  },
  ON_HOLD: {
    onHoldText: `Your account is deactivated but don’t worry. If you've given the needed info, we're reviewing it. Otherwise contact Help Centre to get reactivated quickly.`,
    rfiRequired: `Your account is deactivated but don’t worry. We need some information to reactivate it. Provide the details, and we'll get you going quickly!`
  },

  onHoldText: `Access to your Instarem account has been temporarily suspended due to the expiration of a document. You can reactivate your account, by uploading your new documents.`
};
export const AMAZE_DASHBOARD = {
  REJECTED: {
    riskRejectedText: `As per our internal policy we regret that we are unable to proceed with your registration.`,
    thankYouText: `Thank you for your application and interest in Instarem. We regret to inform that your account cannot be activated as per our internal policies.`
  },

  onHoldText: `Access to your Instarem account has been temporarily suspended due to the expiration of a document. You can reactivate your account, by uploading your new documents.`
};

export const TRANSACTION_TIMELINE = {
  PROCESSING_POPUP:
    'Most of similar transfers are paid out within this time after the money reaches us.',
  PAYMENT_METHOD_POPUP: `This is how long a typical {PAYMENT_METHOD} transfer takes to reach us.`
};

export const DEBITCARD = {
  addNewCardExtraNoteText: `We’ll save this card for your convenience. You can remove it by going to Settings/ Manage Payment Options.`
};

export const INTERVIEWAWAITING = {
  interviewAwaiting_AU_Text: `Our sales team would get in touch with you shortly.`,
  interviewAwaiting_US_Text: `You’ll be notified once your account is ready. This may take up to 24 hours.`,
  interviewAwaiting_US_Text_Header: 'We are reviewing your profile',
  interviewAwaiting_OTHERS_Text: `We are reviewing your details and will get back to you shortly.`
};

export const AADHAR_KYC_OTP_SUCCESS = {
  aadhar_kyc_OTP_success_text: `If not, you can provide your details by choosing an option 
  of ‘Verify using other documents’.`,
  aadhar_kyc_OTP_notsuccess_text: `To verify Aadhaar, enter OTP sent on your Aadhaar registered
  mobile number.`
};

export const CMS_CACHE_DURATION = 30 * 60 * 1000; // 30 minutes
export const CMS_CACHING_FLAG = 'cms_caching';

export const TRANSACTIONDETAILS = {
  transactionDetails_isPayNow_text: `Transfer funds to Instarem using PayNow. Ensure your bank is enabled for PayNow.`,
  transactionDetails_isPayId_text: `Login to your bank account, go to PayID module and make a payment to the given email id.`
};

export const DETAILS_TEXT = {
  YOU_SEND: 'You Send',
  TRANSACTION_DETAILS: 'Transaction Details',
  BANK_TRANSFER_FEE: 'Fee with Bank Transfer',
  CONVERSION_AMOUNT: 'Coneversion Amount',
  RECIPIENT_RECEIVES: 'Recipient Receieves',
  AMOUNT_PAYABLE: 'Amount Payable',
  CGST_NET_FEE: 'CGST on Net Fee Tax',
  SGST_NET_FEE: 'SGST on Net Fee Tax',
  CGST_TRANSACTION_FEE: 'CGST on Transaction Fee Tax',
  SGST_TRANSACTION_FEE: 'SGST on Transaction Fee Tax',
  YOU_PAY_EXACTLY: 'You Pay Exactly',
  TAX: 'Tax',
  TAX_COLLECTED_SOURCE: 'Tax collected at source'
};

/* We will be using only PRODUCTION env as we have different projects for all envs */
export const STATSIG_ENVIRONMENTS = {
  STAGING: 'staging',
  DEVELOPMENT: 'development',
  PRODUCTION: 'production'
};

export const LOCK_FX = 'FX rate is locked for 48 hours.';
export const SUBJECT_TO_CHANGE =
  'The final amount is subject to change due to taxation & other charges.';

export const HUNDRED_THOUSAND = 100000;
export const CLOSING_TEXTS_CHATBOT = [
  'Your conversation is closed.',
  'Your conversation is closed. Close and re-open the widget to re-start the chat with us.',
  'Your chat session has timed out after 10 minutes. If you need any further assistance, please feel free to get back to us. Thank you for choosing us as your preferred remittance partner.',
  '<p>Your conversation has been idle for 5 minutes.</p><br><p>We are closing your conversation for now.</p><br><p>Close and re-open the widget to re-start the chat with us.</p>'
];

export const PASSPORT = 'PASSPORT';
export const NATIONAL_ID = 'NATIONAL_ID';
export const SSN_CARD = 'SSN_CARD';
export const SSN_W2_FORM = 'SSN_W2_FORM';
export const DRIVING_LICENSE = 'DRIVING_LICENSE';
export const HIGH_VALUE_TRANSACTION = 'high_value_transaction';

export const BETA_USERS_SIGNUP_FLAG = 'beta_users_signup';
export const UPSELLING_POPUP_DATA = {
  description:
    'Send {SOURCE_CURRENCY_AND_AMOUNT} or more to enjoy at least {DISCOUNT}% discount in fees.',
  header: 'Send more, pay less!',
  primaryBtnText: 'Update transfer amount',
  secondaryBtnText: 'Continue with existing amount'
};

export const ADDRESS_NOT_FOUND_MSG = ` Looks like we are not able to pull your address automatically.
 Please proceed by filling your address manually.`;

export const CMS_JSON_DATA_VIEW_CONTENT_ID = 'pageJsonDataView';
export const RFI_DETAILS = 'RFI_DETAILS';
export const CMS_ADVERTISEMENT_CONTENT_ID = 'advertisement';
export const WEB_BANNER_DATA = 'WEB_BANNER_DATA';

export const UPSELLING_MODAL_SESSION_KEY = 'Upselling';
export const UPSELLING_POPUP_CMS_NAME = 'TRANSACTION_UPSELLING_POPUP';
export const LEVEL_1_KYC_COMPLETED = 'LEVEL_1_KYC_COMPLETED';
export const LEVEL_2_KYC_ACKNOWLEDGED = 'LEVEL_2_KYC_ACKNOWLEDGED';
export const EKYC_RETRY_COUNT = 2; //Actaully its 3 times. Considering first default case + 2 retry

//Nium forex vKYC modal Session key
export const NF_IS_VKYC_MODAL_CLOSED = 'isModalClosed';
export const IP_MODAL_OPEN = 'IP_MODAL_OPEN';

export const FIRST_TIME_TRANSACTION_POPUP_DATA = {
  offerDescription:
    'Get an amazing {OFFER}% off in transaction fees on your first transfer of min. {AMOUNT_AND_CURRENCY}. Act fast - send money now, save money now!',
  zeroFeeDescription:
    'Enjoy zero transaction fees on your first transfer of min. {AMOUNT_AND_CURRENCY}. Act fast - send money now, save money now!'
};
export const FIRST_TIME_TXN_CMS_NAME = 'SEND_MONEY_FIRST_TIME_TRANSACTION';

export const RECURRING_TRANSFER_DATA = {
  linkedBankError:
    'Uh oh, we encountered an error while processing your transfer with your linked bank account ending in {BANK_ACCOUNT_NUMBER}. Please link another account or try another payment method. Reach out to us via Help Centre for assistance if needed.',
  linkedBankExpireError: `Uh oh, your bank account ending in {BANK_ACCOUNT_NUMBER} may have been unlinked from your bank's website, expired, or has a limit set below the transfer amount. Please delete this account under Payment methods and link a new account.`,
  paidText: `{SAVING_AMOUNT} savings with our 24-hour rate guarantee on recurring transfers`,
  exchangeNotFluctuate: 'Exchange rate didn’t fluctuate in the last 24 hours',
  upcomingData: {
    text: 'We’ll monitor the rate for this transfer 24 hours before execution so you get the best rate available.',
    recurringButtonText: 'Pause this transfer',
    modalHeading: 'Pause this transfer occurrence?',
    modalContent: `By pausing this occurrence, it won't be executed. 
    You can resume it from the app until 24 hours before the execution time. Are you sure you want to pause?`,
    modalPrimaryButton: 'Pause this occurance',
    modalSecondaryButton: 'Cancel'
  },
  scheduledData: {
    text: `You'll receive the most favorable exchange rate within 24 hours prior to the execution time. 
    Keep an eye on the Instarem app to track the current best rate.`,
    recurringButtonText: 'Cancel',
    modalHeading: 'Cancel this transfer occurrence?',
    modalContent: `If you cancel this occurrence, it won't be executed for the current billing period. 
      The next recurring transfer will occur as scheduled. Are you sure you want to cancel this transfer?`,
    modalPrimaryButton: 'Cancel this transfer',
    modalSecondaryButton: 'Go back'
  }
};

export const NIUM_FOREX_FOOTER = {
  footerMsg:
    'Instarem is a brand operated by Nium Pte. Ltd. and its subsidiaries globally. Nium Forex India Pvt. Ltd. is licenced by the Reserve Bank of India as a Category-II Authorized Money Exchange Dealer (AD II), and is a subsidiary of Nium Pte. Ltd.',
  certifiedMsg: 'Instarem SO27001 certified; NIUM Forex ISO27001 certified',
  termsAndCondition: 'Terms & conditions',
  faqs: 'Nium Forex FAQs'
};

export const HEADER_FOOTER_IGNORED_URLS = [NIUM_FOREX_ESIGN_IN_CALLBACK_URL];

export const GENERIC_ERROR_MSG = 'Something went wrong';
export const REFRESH_MSG = 'Please refresh the page';
export const GO_TO_HELP_CENTER = 'Go to Help Centre';
export const SSN_CONFIRM_MODAL = {
  heading: 'Check your information',
  subHeading: `We are about to start the verification process. Please ensure the following information
  is accurate`,
  fullName: `Full name: `,
  dob: `Date of birth: `,
  submitButton: 'Submit',
  chagngeMyDetails: 'Change my details'
};

//Referral
export const REFER_STATUS_FILTER = [
  { id: 'pending', label: 'Pending' },
  { id: 'completed', label: 'Completed' },
  { id: 'all', label: 'All' }
];

export const cashInfoNote =
  'Please use the cash pick-up reference ID instead of transaction number for cash pick-up.';
export const Partner_Location = 'At any partner location';
export const Recipient_Cash_Pickup_Details = 'Recipient cash pickup details';

export const SME_US_HDFC_INR_BENE_REASON_FOR_TRANSFER = ['IR01806', 'IR01811', 'IR01801'];

export const TRANSACTION_HISTORY_PAGE_SIZE = {
  mobile: 3,
  desktop: 7
};
export const TRANSACTION_STAGES_NO_TIMELINE = [
  CANCELLED,
  ON_HOLD,
  CANCELLED,
  REFUND_REQUESTED,
  REFUND_INITIATED,
  REFUND_PROCESSING,
  REFUNDED
];

export const HIDE_RECURRING_TRANSACTION_HELP_CENTRE = [UPCOMING, SCHEDULED];

export const JAPAN_APP_MIGRATION_MODAL = {
  HEADING: `Send money from Japan easily via our app`,
  DESCRIPTION: `Make fast and low-cost transfers from Japan to 60+ countries exclusively through our
  mobile app. `,
  DESCRIPTION_DOWNLOAD_APP: `Scan the QR code to download the app.`,
  DOWNLOAD_THE_APP: `Download the app`,
  LOG_OUT: `Log out`
};

export const RFIDATA = {
  dashboardView: {
    heading: 'Additional information required',
    holdStatusHeading: 'Your transfer is on hold',
    description1: 'We just need a few more details from you to move things forward.',
    description2: 'to keep your account active',
    description3: 'Update your details to proceed',
    submittedBy: 'Submit by {date_time}',
    submittedIn: 'Submit in {date_time} hours'
  },
  rfiScreen: {
    heading: 'Request for Information',
    submitBtn: 'Submit',
    skipBtn: 'Skip for Now',
    note1: 'to keep your account active.',
    note2: 'to proceed with your transfer.',
    submittedBy: 'Submit by {date_time}',
    submittedIn: 'Submit in {date_time} hrs',
    kycNonExpiryNote1: 'Provide before next transfer',
    kycNonExpiryNote2: 'for smooth transfer',
    txnNonExpiryNote1: 'Provide before next transfer',
    txnNonExpiryNote2: 'for smooth transfer'
  },
  activitySection: {
    needSomeInformation: 'We need some information',
    keepAccountActive: 'To keep your account active',
    transferOnHold: 'Your transfer {txn_no} is on hold',
    updateNow: 'Update now',
    submitNow: 'Submit now',
    description1: 'Update it by {date_time}',
    description2: 'update your details by {date_time}',
    description3: 'Update your details to proceed'
  }
};

export const USER_SELECTED_COUNTRY_COOKIE_NAME = 'USER_SELECTED_COUNTRY';
export const REFERRAL_CODE = 'REFERRAL_CODE';
export const STATSIG_EXPERIMENT_NAMES = {
  payinMethodDiscovery: 'payment_discovery_banner_debit_credit_crad'
};

export const NEW_COUPON_FLOW_FLAG = 'new_coupon_flow';
export const COMPARISON_TABLE_FLAG = 'comparison_table';
export const SEND_MONEY_RATE_COMPARISON = {
  header: 'Compare price',
  subHeader: 'When you convert',
  amount: '1000',
  notes: 'The below rates include applicable fees and are the final amounts you will get',
  bestPrice: 'Best price',
  footer:
    'Rates sourced from the company websites on <date> and may vary due to market conditions and transfer methods. Rates may not be updated at the time of your review. Please confirm current rates before initiating your transfer.',
  tableLabel: 'If you use',
  tableValue: 'You’ll get',
  instaremRate: 0,
  compare: 'Compare',
  disclaimer:
    'Rates sourced from the company websites on <date> and may vary due to market conditions and transfer methods test. Rates may not be updated at the time of your review. Please confirm current rates before initiating yourr transfer.'
};
export const DEVICE_ID_COOKIE_NAME = 'deviceId';
export const FAQ_LINK_URL = 'faqlinkUrl';

// CNY Alipay wallet recipient note
export const CNY_WALLET_ID_NOTE = 'We only accept wallet IDs that belong to Chinese nationals';
export const CNY_RECIPIENT_TYPE = `Enter a valid Resident Identity Card number. Passport, foreign IDs, 
and other ID types cannot be used. Payments may fail if an incorrect ID is provided.`;

export const APPLY_COUPON_CMS_DATA = {
  saveText: 'Save',
  upToText: 'up to',
  grabText: '- grab your',
  couponsHereCta: 'coupons here',
  applyCouponFieldPlaceholder: 'Enter coupon code',
  applyCouponFieldCta: 'Apply',
  applyCouponTitle: 'Apply coupon',
  couponsContainerHeading: 'Coupons',
  transferAboveText: 'Transfers above',
  termsText: 'Terms:',
  applyCta: 'Apply',
  couponAppliedWrapper: {
    youSend: 'You send',
    clearCoupon: 'Clear coupon',
    originalAmount: 'Original amount',
    couponApplied: 'Coupon applied',
    youSendOnly: 'You send only'
  },
  couponClearedModal: {
    heading: 'Coupon cleared',
    description:
      'Due to the updates you made, your coupon was cleared. Please review and reapply if needed.',
    primaryCTA: 'Got it',
    secondaryCTA: 'Check available coupons'
  },
  transactionSummaryIpCouponSection: {
    instapoints: {
      applyIpLink: 'Apply InstaPoints',
      ipContainerHeading: 'Apply InstaPoints',
      placeHolder: 'Need a min of {MIN_REDEEM_VALUE} InstaPoints',
      applyCTA: 'Apply',
      removeCTA: 'Remove',
      applyCTAToOffsetFees: 'Apply Instapoints to offset fees',
      offsetContainer: {
        discountedContainer: {
          discountAppliedMsg: 'Discount applied',
          feeOffHeading: '{DISCOUNTED_FEE} {SOURCE_CURRENCY} off',
          feeOffDescription: 'with {IP_USED_FOR_DISCOUNT} InstaPoints',
          discountClearCTA: 'Clear'
        },
        offerContainer: {
          feeApplyHeading: 'Apply InstaPoints',
          feeApplyDescription:
            'You get {DISCOUNTED_FEE} {SOURCE_CURRENCY} off with {IP_NEED_FOR_DISCOUNT} IPs',
          discountApplyCTA: 'Apply'
        }
      }
    },
    coupons: {
      applyCouponLink: 'Apply coupon',
      zeroCouponContainer: {
        zeroCouponHeading: 'Have a coupon?',
        zeroCouponDescription: 'Apply code here',
        zeroCouponApplyCTA: 'Apply',
        zeroCouponDiscountOfferMsg: 'Discount'
      },
      couponsAvailContainer: {
        couponAvailHeading: 'Apply coupon',
        availableCouponTag: '{NO_OF_COUPONS} Available',
        couponAvailViewCTA: 'View',
        couponsAvailableDiscountOfferMsg: 'Discount'
      },
      couponAppliedContainer: {
        couponAppliedHeading: '{COUPON_AMOUNT} {SOURCE_CURRENCY} off',
        couponAppliedDescription: 'With a coupon code',
        couponAppliedClearCTA: 'Clear',
        couponAppliedDiscountMsg: 'Discount applied'
      }
    }
  }
};

export const NOTE_NRIC = {
  note: "Don't have a FIN? Please provide your NRIC instead via our ",
  boldText: 'NRIC',
  ctaText: 'Help Centre here'
};
export const PAYTO_BANNER = 'payto_banner';

export const SUPPORTED_BANK_STATEMENT_DOC_TYPES = ['BANK_STATEMENT', 'RFI_PROOF_OF_PAYMENT'];
export const BANK_STATEMENT_INSTRUCTIONS = {
  viewSampleText: 'view sample',
  bankStatementText: 'Bank Statement',
  sampleIllustration: 'Sample illustration',
  bankStatementGuideLine:
    'If the bank statement doesn’t show the transfer to Instarem, provide an alternative proof (e.g screenshot of your transaction history showing the transfer)'
};

export const CAPTCHA_ERROR_MESSAGES = {
  CAPTCHA_VERIFICATION_FAILED_MESSAGE:
    'Captcha verification failed. Please try again after sometime!',
  CAPTCHA_ATTEMPT_EXCEEDED_MESSAGE: 'Captcha attempt limit exceeded. Try again after one hour!',
  VISIBLE_CAPTCHA_VERIFICATION_FAILED_MESSAGE:
    'Visible captcha verification failed. Please try again!'
};

export const APPLE_PAY_ENABLED_COUNTRIES = [SG];
export const NON_MYR_BENE_LIMIT_MSG = `Non-residents with Malaysian bank 
      accounts can receive up to 10,000 MYR daily. Transfers above this limit will be rejected.`;

export const STATEMENTS = {
  tncConfirmation: 'I confirm I have read and accepted the ',
  privacyStatement:
    'By checking this box, you agree to receive marketing updates about Instarem’s products, services, and offers. You can unsubscribe anytime using the link in our messages. We don’t sell your data or share it with third parties. See our '
};
export const STRIPE_APPLE_PAY_DEFAULT_DELAY_IN_MS = 8000;

export const NIUM_FOREX_HELP_EMAIL_MESSAGE = {
  subject: 'Nium Forex support request from ',
  body: `Transaction number: Please input transaction number if applicable\nIssue description: `,
  email: 'instarem.support@instarem.co.in'
};

export const CDN_FLAGS_BASE_URL = 'https://cdn.instarem.com/images/flags';
export const IS_TURNSTILE_ENABLED = 'public_turnstile_enabled';

export const INSTAREM_BASE_IMAGES_URL = 'https://cdn.instarem.com/images/consumer/';
export const MALAYSIA_VIEW_SAMPLE_MODAL_DATA = {
  EVISA: {
    title: 'Malaysia eVISA',
    subtitle: 'Sample illustration',
    description: 'Find the eVISA number under the eVisa Holder Information section.'
  },
  EPASS: {
    title: 'Malaysia ePASS',
    subtitle: 'Sample illustration',
    description:
      'Find the ePASS number printed vertically on the left side of the document near the QR code.'
  }
};
